webpackJsonp([1],{

/***/ 108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Plugin__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Plugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_plugins_Plugin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_Todo__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_Todo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_plugins_Todo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_plugins_TimeNote__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_plugins_TimeNote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_plugins_TimeNote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_plugins_Tomato__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_plugins_Tomato___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_plugins_Tomato__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_plugins_AnnualPlan__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_plugins_AnnualPlan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_plugins_AnnualPlan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_plugins_Birthday__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_plugins_Birthday___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_plugins_Birthday__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_plugins_RememberCurve__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_plugins_RememberCurve___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_plugins_RememberCurve__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_plugins_BookList__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_plugins_BookList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_plugins_BookList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_plugins_Random__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_plugins_Random___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_plugins_Random__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_plugins_MarkDown__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_plugins_MarkDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_plugins_MarkDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_plugins_Dashboard__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_plugins_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_plugins_Dashboard__);














__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a
  }, {
    path: '/plugin',
    name: 'plugin',
    component: __WEBPACK_IMPORTED_MODULE_3__components_plugins_Plugin___default.a,
    children: [{
      path: 'todo',
      name: 'todo',
      component: __WEBPACK_IMPORTED_MODULE_4__components_plugins_Todo___default.a
    }, {
      path: 'timenote',
      name: 'timenote',
      component: __WEBPACK_IMPORTED_MODULE_5__components_plugins_TimeNote___default.a
    }, {
      path: 'tomato',
      name: 'tomato',
      component: __WEBPACK_IMPORTED_MODULE_6__components_plugins_Tomato___default.a
    }, {
      path: 'annualPlan',
      name: 'annualPlan',
      component: __WEBPACK_IMPORTED_MODULE_7__components_plugins_AnnualPlan___default.a
    }, {
      path: 'birthday',
      name: 'birthday',
      component: __WEBPACK_IMPORTED_MODULE_8__components_plugins_Birthday___default.a
    }, {
      path: 'rememberCurve',
      name: 'rememberCurve',
      component: __WEBPACK_IMPORTED_MODULE_9__components_plugins_RememberCurve___default.a
    }, {
      path: 'bookList',
      name: 'bookList',
      component: __WEBPACK_IMPORTED_MODULE_10__components_plugins_BookList___default.a
    }, {
      path: 'random',
      name: 'random',
      component: __WEBPACK_IMPORTED_MODULE_11__components_plugins_Random___default.a
    }, {
      path: 'markdown',
      name: 'markdown',
      component: __WEBPACK_IMPORTED_MODULE_12__components_plugins_MarkDown___default.a
    }]
  }, {
    path: '/dashboard',
    name: 'dashboard',
    component: __WEBPACK_IMPORTED_MODULE_13__components_plugins_Dashboard___default.a
  }]
}));

/***/ }),

/***/ 306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var plugins = [{
  id: 1,
  name: 'Todo',
  icon: 'list',
  desc: '记录的任务列表',
  bgColor: { top: '#3EC69A', bottom: '#3768BE' },
  link: 'todo'
}, {
  id: 2,
  name: 'Time Note',
  icon: 'receipt',
  desc: '时间记录法',
  bgColor: { top: '#2E7FBF', bottom: '#986BAD' },
  link: 'timenote'
}, {
  id: 3,
  name: 'Tomato Time',
  icon: 'access_time',
  desc: 'Tomato',
  bgColor: { top: '#FFAE80', bottom: '#E15A84' },
  link: 'tomato'
}, {
  id: 4,
  name: 'Annual plan',
  icon: 'event_note',
  desc: 'make splan for this year!',
  bgColor: { top: '#74D0F8', bottom: '#3A3377' },
  link: 'annualPlan'
}, {
  id: 6,
  name: 'Birthday Notebook',
  icon: 'cake',
  desc: '记录亲朋好友的生日时间',
  bgColor: { top: '#3EC69A', bottom: '#3768BE' },
  link: 'birthday'
}, {
  id: 7,
  name: 'Memory Curve Line',
  icon: 'timeline',
  desc: '根据艾宾浩斯记忆曲线来复习知识',
  bgColor: { top: '#FFAE80', bottom: '#E15A84' },
  link: 'rememberCurve'
}, {
  id: 8,
  name: 'Random Choose',
  icon: 'cached',
  desc: '帮你解决选择困难症',
  bgColor: { top: '#74D0F8', bottom: '#3A3377' },
  link: 'random'
}];
/* harmony default export */ __webpack_exports__["a"] = (plugins);

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(366)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(698),
  /* template */
  __webpack_require__(342),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(375)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(701),
  /* template */
  __webpack_require__(351),
  /* scopeId */
  "data-v-67b35cf3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 316:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 317:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(378)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(697),
  /* template */
  __webpack_require__(353),
  /* scopeId */
  "data-v-844cb54c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(364)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(699),
  /* template */
  __webpack_require__(340),
  /* scopeId */
  "data-v-235cdfce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(371)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(700),
  /* template */
  __webpack_require__(347),
  /* scopeId */
  "data-v-4d4f5892",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(367)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(702),
  /* template */
  __webpack_require__(343),
  /* scopeId */
  "data-v-3a961de0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(363)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(703),
  /* template */
  __webpack_require__(339),
  /* scopeId */
  "data-v-0b303a26",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(369)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(704),
  /* template */
  __webpack_require__(345),
  /* scopeId */
  "data-v-410681fb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(377)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(705),
  /* template */
  __webpack_require__(352),
  /* scopeId */
  "data-v-756d7da5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(384)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(706),
  /* template */
  __webpack_require__(359),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(376)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(707),
  /* template */
  null,
  /* scopeId */
  "data-v-73ff4ece",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(385)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(708),
  /* template */
  __webpack_require__(360),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(380)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(709),
  /* template */
  __webpack_require__(355),
  /* scopeId */
  "data-v-a17e359e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(374)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(710),
  /* template */
  __webpack_require__(350),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(370)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(711),
  /* template */
  __webpack_require__(346),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(365)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(712),
  /* template */
  __webpack_require__(341),
  /* scopeId */
  "data-v-2e6aa6dd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(379)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(713),
  /* template */
  __webpack_require__(354),
  /* scopeId */
  "data-v-92b9c378",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(373)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(714),
  /* template */
  __webpack_require__(349),
  /* scopeId */
  "data-v-58cedaf0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(368)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(715),
  /* template */
  __webpack_require__(344),
  /* scopeId */
  "data-v-3ae7301c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(382)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(716),
  /* template */
  __webpack_require__(357),
  /* scopeId */
  "data-v-ce5b6978",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(372)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(717),
  /* template */
  __webpack_require__(348),
  /* scopeId */
  "data-v-54e3dafc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(381)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(718),
  /* template */
  __webpack_require__(356),
  /* scopeId */
  "data-v-ad19b2a2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(383)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(719),
  /* template */
  __webpack_require__(358),
  /* scopeId */
  "data-v-d50d4e48",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 339:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "header"
  }), _vm._v(" "), _c('md-whiteframe', {
    staticClass: "form-area",
    attrs: {
      "md-elevation": "2"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "form-area-input",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-input-container', [_c('md-input', {
    attrs: {
      "placeholder": "计划名称"
    },
    model: {
      value: (_vm.planContent),
      callback: function($$v) {
        _vm.planContent = $$v
      },
      expression: "planContent"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "form-area-input",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('date-picker', {
    attrs: {
      "date": _vm.startTime
    }
  }, [_c('md-input-container', [_c('md-input', {
    attrs: {
      "placeholder": "开始时间"
    },
    model: {
      value: (_vm.startTime.time),
      callback: function($$v) {
        _vm.startTime.time = $$v
      },
      expression: "startTime.time"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "form-area-input",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('date-picker', {
    attrs: {
      "date": _vm.endTime
    }
  }, [_c('md-input-container', [_c('md-input', {
    attrs: {
      "placeholder": "截止时间"
    },
    model: {
      value: (_vm.endTime.time),
      callback: function($$v) {
        _vm.endTime.time = $$v
      },
      expression: "endTime.time"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', [_c('div', [_c('md-button', {
    staticClass: "md-primary md-raised add-plan-button",
    nativeOn: {
      "click": function($event) {
        _vm.addPlan($event)
      }
    }
  }, [_c('md-icon', [_vm._v("add")])], 1)], 1)])], 1)], 1), _vm._v(" "), _c('md-whiteframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.plans.length),
      expression: "plans.length"
    }],
    staticClass: "main",
    attrs: {
      "md-elevation": "2"
    }
  }, [_c('md-layout', {
    staticClass: "plan-header",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_vm._v("计划名称")]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_vm._v("计划周期")]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_vm._v("截止日期")]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_vm._v("完成比例")])], 1), _vm._v(" "), _vm._l((_vm.plans), function(plan, index) {
    return _c('md-layout', {
      key: index,
      staticClass: "plan-item",
      attrs: {
        "md-gutter": ""
      }
    }, [_c('md-layout', {
      staticClass: "plan-item",
      attrs: {
        "md-flex": "25"
      }
    }, [_vm._v(_vm._s(plan.content))]), _vm._v(" "), _c('md-layout', {
      staticClass: "plan-item",
      attrs: {
        "md-flex": "25"
      }
    }, [_vm._v(_vm._s(plan.startTime))]), _vm._v(" "), _c('md-layout', {
      staticClass: "plan-item",
      attrs: {
        "md-flex": "25"
      }
    }, [_vm._v(_vm._s(plan.endTime))]), _vm._v(" "), _c('md-layout', {
      staticClass: "plan-item",
      attrs: {
        "md-flex": "25"
      }
    }, [_vm._v(_vm._s(plan.progress) + "%")]), _vm._v(" "), _c('md-button', {
      staticClass: "md-icon-button md-mini md-dense edit-plan-button md-primary",
      attrs: {
        "id": "editPlan"
      },
      nativeOn: {
        "click": function($event) {
          _vm.editPlan(plan)
        }
      }
    }, [_c('md-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('md-button', {
      staticClass: "md-icon-button md-mini md-dense delete-plan-button md-accent",
      nativeOn: {
        "click": function($event) {
          _vm.removePlan(plan.id)
        }
      }
    }, [_c('md-icon', [_vm._v("delete")])], 1), _vm._v(" "), _c('md-progress', {
      staticClass: "md-accent",
      attrs: {
        "md-progress": +plan.progress
      }
    })], 1)
  })], 2), _vm._v(" "), _c('md-dialog', {
    ref: "editPlanDialog",
    attrs: {
      "md-open-from": "#editPlan",
      "md-close-to": "#editPlan"
    }
  }, [_c('md-dialog-title', [_vm._v("编辑计划")]), _vm._v(" "), _c('md-dialog-content', [_c('md-input-container', [_c('md-input', {
    attrs: {
      "placeholder": "计划名称"
    },
    model: {
      value: (_vm.editPlanObj.content),
      callback: function($$v) {
        _vm.editPlanObj.content = $$v
      },
      expression: "editPlanObj.content"
    }
  })], 1), _vm._v(" "), _c('date-picker', {
    attrs: {
      "date": _vm.editPlanObj.startTime
    }
  }, [_c('md-input-container', [_c('md-input', {
    attrs: {
      "placeholder": "开始时间"
    },
    model: {
      value: (_vm.editPlanObj.startTime.time),
      callback: function($$v) {
        _vm.editPlanObj.startTime.time = $$v
      },
      expression: "editPlanObj.startTime.time"
    }
  })], 1)], 1), _vm._v(" "), _c('date-picker', {
    attrs: {
      "date": _vm.editPlanObj.endTime
    }
  }, [_c('md-input-container', [_c('md-input', {
    attrs: {
      "placeholder": "截止时间"
    },
    model: {
      value: (_vm.editPlanObj.endTime.time),
      callback: function($$v) {
        _vm.editPlanObj.endTime.time = $$v
      },
      expression: "editPlanObj.endTime.time"
    }
  })], 1)], 1), _vm._v(" "), _c('md-input-container', [_c('md-input', {
    attrs: {
      "placeholder": "进度",
      "type": "number"
    },
    model: {
      value: (_vm.editPlanObj.progress),
      callback: function($$v) {
        _vm.editPlanObj.progress = $$v
      },
      expression: "editPlanObj.progress"
    }
  })], 1)], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog('cancel')
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog('confirm')
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 340:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "pugin-group"
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, _vm._l((_vm.cards), function(card, index) {
    return _c('md-layout', {
      key: card.id,
      staticClass: "plugin-card",
      attrs: {
        "md-flex": "33"
      },
      nativeOn: {
        "click": function($event) {
          _vm.goToPlugin(card.link)
        }
      }
    }, [_c('plugin-card', {
      attrs: {
        "name": card.name,
        "desc": card.desc,
        "bg-color": card.bgColor
      }
    })], 1)
  }))], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 341:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "timenote-header"
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('span', {
    staticClass: "timenote-header-day"
  }, [_vm._v("星期" + _vm._s(_vm.noteWeekday))]), _vm._v(" "), _c('span', {
    staticClass: "timenote-header-date"
  }, [_vm._v(" " + _vm._s(_vm.noteDate))])]), _vm._v(" "), _c('md-layout', [_c('md-button-toggle', {
    attrs: {
      "md-single": ""
    }
  }, [_c('md-button', {
    staticClass: "md-primary md-raised",
    nativeOn: {
      "click": function($event) {
        _vm.chooseDate('yesterday')
      }
    }
  }, [_vm._v("\n            昨天\n          ")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary md-raised",
    nativeOn: {
      "click": function($event) {
        _vm.chooseDate('today')
      }
    }
  }, [_vm._v("\n            今天\n          ")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "date": _vm.noteChooseDate
    },
    on: {
      "change": _vm.dateChange
    }
  }, [_c('md-button', {
    staticClass: "md-primary md-raised",
    style: ({
      margin: 0,
      padding: 0,
      minHeight: '40px'
    })
  }, [_vm._v("\n              自定义\n            ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-accent timenote-setting",
    nativeOn: {
      "click": function($event) {
        _vm.toggleRightSidenav($event)
      }
    }
  }, [_vm._v("\n      设置\n    ")])], 1), _vm._v(" "), _c('md-whiteframe', {
    attrs: {
      "md-elevation": "2"
    }
  }, [_c('div', {
    staticClass: "input-area"
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-input-container', [_c('md-input', {
    attrs: {
      "placeholder": "添加事件"
    },
    model: {
      value: (_vm.thingContentInputVal),
      callback: function($$v) {
        _vm.thingContentInputVal = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "thingContentInputVal"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "use-time",
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.isTimeInputErrorMsg
    }
  }, [_c('md-input', {
    attrs: {
      "type": "number",
      "placeholder": "用时（h）"
    },
    model: {
      value: (_vm.thingTimeInputVal),
      callback: function($$v) {
        _vm.thingTimeInputVal = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "thingTimeInputVal"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isTimeInputErrorMsg),
      expression: "isTimeInputErrorMsg"
    }],
    staticClass: "md-error"
  }, [_vm._v("一天只有24小时哦！")])], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "movie"
    }
  }, [_vm._v("标签")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "movie",
      "id": "movie"
    },
    model: {
      value: (_vm.tag),
      callback: function($$v) {
        _vm.tag = $$v
      },
      expression: "tag"
    }
  }, _vm._l((_vm.tags), function(tag) {
    return _c('md-option', {
      key: tag.id,
      attrs: {
        "value": tag.text
      }
    }, [_vm._v(_vm._s(tag.text))])
  }))], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "movie"
    }
  }, [_vm._v("子标签")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "movie",
      "id": "movie",
      "disabled": _vm.childTags.length === 0
    },
    model: {
      value: (_vm.childTag),
      callback: function($$v) {
        _vm.childTag = $$v
      },
      expression: "childTag"
    }
  }, _vm._l((_vm.childTags), function(childTag) {
    return _c('md-option', {
      key: childTag.id,
      attrs: {
        "value": childTag.text
      }
    }, [_vm._v(_vm._s(childTag.text))])
  }))], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary add-btn",
    attrs: {
      "disabled": _vm.thingContentInputVal.length === 0
    },
    nativeOn: {
      "click": function($event) {
        _vm.addTimenote($event)
      }
    }
  }, [_c('md-icon', [_vm._v("add")])], 1)], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.timenotes.length > 0),
      expression: "timenotes.length>0"
    }],
    staticClass: "timenote-group"
  }, [_c('md-table-card', [_c('md-table', [_c('md-table-header', [_c('md-table-row', [_c('md-table-head', [_vm._v("事件名称")]), _vm._v(" "), _c('md-table-head', [_vm._v("用时")]), _vm._v(" "), _c('md-table-head', [_vm._v("标签")])], 1)], 1), _vm._v(" "), _c('md-table-body', _vm._l((_vm.timenotes), function(timenote) {
    return _c('md-table-row', {
      key: timenote.id
    }, [_c('md-table-cell', [_vm._v(_vm._s(timenote.text))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(timenote.time))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(timenote.tag) + " -- " + _vm._s(timenote.childTag))])], 1)
  }))], 1)], 1), _vm._v(" "), _vm._l((_vm.timenotes), function(timenote) {
    return _c('div', {
      key: timenote.id,
      staticClass: "timenote-item",
      on: {
        "mouseover": function($event) {
          _vm.selectedOne = timenote.id
        },
        "mouseout": function($event) {
          _vm.selectedOne = ''
        }
      }
    })
  })], 2), _vm._v(" "), _c('md-whiteframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.timenotes.length > 0),
      expression: "timenotes.length>0"
    }],
    staticClass: "timenote-chart",
    attrs: {
      "md-elevation": "2"
    }
  }, [_c('pie-chart', {
    attrs: {
      "option": _vm.chartOption
    }
  })], 1), _vm._v(" "), _c('md-sidenav', {
    ref: "rightSidenav",
    staticClass: "md-right",
    on: {
      "open": function($event) {
        _vm.open('Right')
      },
      "close": function($event) {
        _vm.close('Right')
      }
    }
  }, [_c('md-toolbar', [_c('div', {
    staticClass: "md-toolbar-container"
  }, [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v("Time Note 设置")])])]), _vm._v(" "), _c('div', {
    staticClass: "setting-container"
  }, [_c('div', {
    staticClass: "setting-add-tag"
  }, [_c('md-input-container', [_c('md-input', {
    attrs: {
      "placeholder": "添加标签,按回车确定"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.addTag($event)
      }
    },
    model: {
      value: (_vm.newTagVal),
      callback: function($$v) {
        _vm.newTagVal = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "newTagVal"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "setting-tag-list"
  }, _vm._l((_vm.tags), function(tag) {
    return _c('span', {
      key: tag.id,
      staticClass: "setting-tag-item",
      on: {
        "click": function($event) {
          _vm.chooseParentTag(tag)
        },
        "mouseover": function($event) {
          _vm.hoverTagOne = tag.id
        },
        "mouseout": function($event) {
          _vm.hoverTagOne = ''
        }
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.hoverTagOne === tag.id),
        expression: "hoverTagOne===tag.id"
      }],
      staticClass: "delete-tag",
      on: {
        "click": function($event) {
          _vm.removeTag(tag.id)
        }
      }
    }, [_vm._v("x")]), _vm._v("\n            " + _vm._s(tag.text) + "\n          ")])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "setting-add-tag"
  }, [_c('md-input-container', [_c('md-input', {
    attrs: {
      "placeholder": '添加' + _vm.selectedParentTag.text + '子标签,按回车确定'
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.addChildTag($event)
      }
    },
    model: {
      value: (_vm.newChildTagVal),
      callback: function($$v) {
        _vm.newChildTagVal = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "newChildTagVal"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "setting-tag-list"
  }, _vm._l((_vm.childTags), function(childTag) {
    return _c('span', {
      key: childTag.id,
      staticClass: "setting-tag-item",
      on: {
        "click": function($event) {
          _vm.removeChildTag(childTag.id)
        }
      }
    }, [_vm._v(_vm._s(childTag.text))])
  }))], 1)]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-accent",
    nativeOn: {
      "click": function($event) {
        _vm.closeRightSidenav($event)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 342:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('Header'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 343:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('div', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-item"
  }, [_vm._v("Plugins")])])
},staticRenderFns: []}

/***/ }),

/***/ 344:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book-container"
  }, [_c('div', {
    staticClass: "book-progress"
  }, [_vm._v("\n    " + _vm._s(_vm.progress) + "%\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "book-content"
  }, [_c('div', {
    staticClass: "book-title"
  }, [_vm._t("title")], 2), _vm._v(" "), _c('div', {
    staticClass: "book-author"
  }, [_vm._t("author")], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('div', {
    staticClass: "birthday-header"
  }, [_c('span', {
    staticClass: "birthday-header-day"
  }, [_vm._v("今天")]), _vm._v(" "), _c('span', {
    staticClass: "birthday-header-date"
  }, [_vm._v("星期六 5月6日")]), _vm._v(" "), _c('md-button-toggle', {
    staticClass: "birthday-add-button",
    attrs: {
      "md-single": ""
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary ",
    attrs: {
      "id": "addbirthday"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openDialog($event)
      }
    }
  }, [_c('md-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    attrs: {
      "id": "addbirthday"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleRightSidenav($event)
      }
    }
  }, [_c('md-icon', [_vm._v("settings")])], 1)], 1)], 1), _vm._v(" "), _c('time-line', _vm._l((_vm.birthdayList), function(birthday) {
    return _c('timeline-item', {
      key: birthday.id
    }, [_c('md-whiteframe', {
      attrs: {
        "md-elevation": "4"
      }
    }, [_c('div', {
      staticClass: "birthday-card",
      class: {
        birthdayIsNow: _vm.nowDate === birthday.date
      }
    }, [_c('div', {
      staticClass: "birthday-card-header"
    }, [_c('div', {
      staticClass: "birthday-card-date"
    }, [_vm._v(_vm._s(birthday.date) + " " + _vm._s(birthday.text))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.nowDate === birthday.date),
        expression: "nowDate===birthday.date"
      }],
      staticClass: "birthday-cake"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(316),
        "alt": "cake"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "birthday-card-content"
    }, [_c('div', [_vm._v("\n              " + _vm._s(birthday.remark) + " " + _vm._s(_vm.nowDate) + "\n            ")])])])])], 1)
  })), _vm._v(" "), _c('md-dialog', {
    ref: "addBirthdayDialog",
    attrs: {
      "md-open-from": "#addBirthday",
      "md-close-to": "#addBirthday"
    }
  }, [_c('md-dialog-title', [_vm._v("添加书单")]), _vm._v(" "), _c('md-dialog-content', [_c('md-input-container', [_c('md-input', {
    attrs: {
      "placeholder": "姓名"
    },
    model: {
      value: (_vm.personName),
      callback: function($$v) {
        _vm.personName = $$v
      },
      expression: "personName"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('md-input', {
    attrs: {
      "placeholder": "时间"
    },
    model: {
      value: (_vm.personTime),
      callback: function($$v) {
        _vm.personTime = $$v
      },
      expression: "personTime"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('md-input', {
    attrs: {
      "placeholder": "备注"
    },
    model: {
      value: (_vm.remark),
      callback: function($$v) {
        _vm.remark = $$v
      },
      expression: "remark"
    }
  })], 1)], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog('cancel')
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog('confirm')
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('md-sidenav', {
    ref: "rightSidenav",
    staticClass: "md-right"
  }, [_c('md-toolbar', [_c('div', {
    staticClass: "md-toolbar-container"
  }, [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v("Birthday 设置")])])]), _vm._v(" "), _c('div', {
    staticClass: "setting-container"
  }, [_c('md-input-container', [_c('md-input', {
    attrs: {
      "placeholder": "什么时候和ta在一起"
    },
    model: {
      value: (_vm.togetherTime),
      callback: function($$v) {
        _vm.togetherTime = $$v
      },
      expression: "togetherTime"
    }
  })], 1), _vm._v(" "), _c('md-switch', {
    staticClass: "md-primary",
    attrs: {
      "name": "my-test1"
    },
    model: {
      value: (_vm.isShowAnniversary),
      callback: function($$v) {
        _vm.isShowAnniversary = $$v
      },
      expression: "isShowAnniversary"
    }
  }, [_vm._v("显示纪念日")]), _vm._v(" "), _c('md-switch', {
    staticClass: "md-primary",
    attrs: {
      "name": "my-test1"
    },
    model: {
      value: (_vm.isShowFestival),
      callback: function($$v) {
        _vm.isShowFestival = $$v
      },
      expression: "isShowFestival"
    }
  }, [_vm._v("显示重要节日")])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-accent",
    nativeOn: {
      "click": function($event) {
        _vm.saveSetting($event)
      }
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 346:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', [_c('md-input-container', {
    staticClass: "input-area"
  }, [_c('md-input', {
    attrs: {
      "placeholder": "计划名称"
    },
    model: {
      value: (_vm.rememberContent),
      callback: function($$v) {
        _vm.rememberContent = $$v
      },
      expression: "rememberContent"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', [_c('div', [_c('md-button', {
    staticClass: "md-primary md-raised",
    nativeOn: {
      "click": function($event) {
        _vm.addRemeber()
      }
    }
  }, [_c('md-icon', [_vm._v("add")])], 1)], 1)])], 1), _vm._v(" "), _c('div', [_c('md-whiteframe', {
    staticClass: "calendar clearfix",
    attrs: {
      "md-elevation": "2"
    }
  }, [_c('div', {
    staticClass: "calendar-control"
  }, [_c('md-button-toggle', {
    attrs: {
      "md-single": ""
    }
  }, [_c('md-button', {
    staticClass: "md-primary md-raised",
    nativeOn: {
      "click": function($event) {
        _vm.changeMonth('last')
      }
    }
  }, [_c('md-icon', [_vm._v("navigate_before")])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary md-raised",
    nativeOn: {
      "click": function($event) {
        _vm.changeMonth('now')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.currentMonth + 1) + "月\n          ")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary md-raised",
    nativeOn: {
      "click": function($event) {
        _vm.changeMonth('next')
      }
    }
  }, [_c('md-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('div')], 1), _vm._v(" "), _c('div', {
    staticClass: "calendar-header clearfix"
  }, _vm._l((_vm.weekdays), function(weekday, index) {
    return _c('div', {
      staticClass: "day"
    }, [_vm._v(_vm._s(weekday))])
  })), _vm._v(" "), _c('div', {
    staticClass: "calendar-days"
  }, _vm._l((_vm.calendar), function(day, index) {
    return _c('div', {
      key: index,
      staticClass: "day",
      on: {
        "click": function (event) {
          _vm.chooseDay(event, _vm.timeline[day.date])
        }
      }
    }, [_c('div', {
      staticClass: "day-number"
    }, [_vm._v(_vm._s(day.value))]), _vm._v(" "), (_vm.timeline[day.date]) ? _c('div', {
      staticClass: "task-group"
    }, _vm._l((_vm.timeline[day.date]), function(item) {
      return _c('div', {
        staticClass: "task"
      }, [_vm._v(_vm._s(item.rememberContent))])
    })) : _vm._e()])
  }))])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 347:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-card', {
    style: (_vm.cardStyle)
  }, [_c('md-card-media', [_c('div', {
    staticClass: "plugin-img"
  })]), _vm._v(" "), _c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v(_vm._s(_vm.desc))])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 348:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 349:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-whiteframe', {
    staticClass: "container",
    attrs: {
      "md-elevation": "4"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('md-icon', {
    staticClass: "setting",
    nativeOn: {
      "click": function($event) {
        _vm.toggleRightSidenav($event)
      }
    }
  }, [_vm._v("settings")]), _vm._v(" "), _c('div', {
    staticClass: "header-tip"
  }, [_vm._v(_vm._s(_vm.isWorkTime ? _vm.tipWorkText : _vm.tipRestText))])], 1), _vm._v(" "), _c('div', {
    staticClass: "task-area"
  }, [_c('div', [_vm._v(_vm._s(_vm.taskName))])]), _vm._v(" "), _c('div', {
    staticClass: "time-area"
  }, _vm._l((_vm.toMinutsText), function(word, index) {
    return _c('div', {
      key: index,
      staticClass: "time-item"
    }, [_vm._v(_vm._s(word))])
  })), _vm._v(" "), _c('div', {
    staticClass: "control-area"
  }, [_c('md-layout', {
    staticClass: "control-play",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "33"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button md-primary"
  }, [_c('md-icon', {
    staticClass: "md-accent",
    nativeOn: {
      "click": function($event) {
        _vm.stopTomato($event)
      }
    }
  }, [_vm._v("stop")])], 1)], 1), _vm._v(" "), _c('md-layout', [_c('md-button', {
    staticClass: "md-fab",
    nativeOn: {
      "click": function($event) {
        _vm.toggleTomato($event)
      }
    }
  }, [_c('md-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPause),
      expression: "isPause"
    }]
  }, [_vm._v("play_arrow")]), _vm._v(" "), _c('md-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isPause),
      expression: "!isPause"
    }]
  }, [_vm._v("pause")])], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "33"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button md-primary"
  }, [_c('md-icon', {
    staticClass: "md-accent",
    nativeOn: {
      "click": function($event) {
        _vm.nextTomato($event)
      }
    }
  }, [_vm._v("skip_next")])], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('md-sidenav', {
    ref: "rightSidenav",
    staticClass: "md-right"
  }, [_c('md-toolbar', [_c('div', {
    staticClass: "md-toolbar-container"
  }, [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v("番茄时钟设置")])])]), _vm._v(" "), _c('div', {
    staticClass: "setting-container"
  }, [_c('div', {
    staticClass: "setting-focus-time"
  }, [_c('md-input-container', [_c('label', [_vm._v("专注时间(分钟)")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "设置专注时间"
    },
    model: {
      value: (_vm.settingFocusTime),
      callback: function($$v) {
        _vm.settingFocusTime = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "settingFocusTime"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "setting-rest-time"
  }, [_c('md-input-container', [_c('label', [_vm._v("休息时间(分钟)")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "设置休息时间"
    },
    model: {
      value: (_vm.settingRestTime),
      callback: function($$v) {
        _vm.settingRestTime = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "settingRestTime"
    }
  })], 1)], 1)]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-accent",
    nativeOn: {
      "click": function($event) {
        _vm.saveSetting($event)
      }
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 350:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('div', [_c('md-input-container', {
    staticClass: "square-add-todo"
  }, [_c('md-input', {
    attrs: {
      "placeholder": "输入随机值，以/分割，输入完成按回车添加"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.splitRandomVal($event)
      }
    },
    model: {
      value: (_vm.randomVal),
      callback: function($$v) {
        _vm.randomVal = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "randomVal"
    }
  })], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.duang($event)
      }
    }
  }, [_vm._v("\n      Duang!!!\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "random-group clearfix"
  }, [_c('transition-group', {
    attrs: {
      "tag": "div",
      "name": "random"
    }
  }, _vm._l((_vm.cards), function(card) {
    return _c('div', {
      key: card.id,
      staticClass: "random-card",
      on: {
        "click": function($event) {
          _vm.seletedCardId = card.id
        }
      }
    }, [_c('div', {
      staticClass: "card"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.seletedCardId === card.id || _vm.allShow),
        expression: "seletedCardId===card.id || allShow"
      }]
    }, [_vm._v(_vm._s(card.value))])])])
  }))], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 351:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-whiteframe', {
    attrs: {
      "md-elevation": "4"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Timie")])])])
},staticRenderFns: []}

/***/ }),

/***/ 352:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('div', {
    staticClass: "book-header"
  }, [_c('span', {
    staticClass: "book-header-day"
  }, [_vm._v("今天")]), _vm._v(" "), _c('span', {
    staticClass: "book-header-date"
  }, [_vm._v("星期六 5月6日")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary book-add-button",
    attrs: {
      "id": "addBook"
    },
    nativeOn: {
      "click": function($event) {
        _vm.addBook($event)
      }
    }
  }, [_c('md-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "book-group",
    attrs: {
      "md-gutter": ""
    }
  }, _vm._l((_vm.books), function(book) {
    return _c('md-layout', {
      key: book.id
    }, [_c('book', {
      attrs: {
        "progress": book.progress
      }
    }, [_c('span', {
      slot: "title"
    }, [_vm._v(_vm._s(book.name))]), _vm._v(" "), _c('span', {
      slot: "author"
    }, [_vm._v(_vm._s(book.author))])])], 1)
  })), _vm._v(" "), _c('md-dialog', {
    ref: "addBookDialog",
    attrs: {
      "md-open-from": "#addBook",
      "md-close-to": "#addBook"
    }
  }, [_c('md-dialog-title', [_vm._v("添加书单")]), _vm._v(" "), _c('md-dialog-content', [_c('md-input-container', [_c('md-input', {
    attrs: {
      "placeholder": "书名"
    },
    model: {
      value: (_vm.bookName),
      callback: function($$v) {
        _vm.bookName = $$v
      },
      expression: "bookName"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('md-input', {
    attrs: {
      "placeholder": "作者"
    },
    model: {
      value: (_vm.bookAuthor),
      callback: function($$v) {
        _vm.bookAuthor = $$v
      },
      expression: "bookAuthor"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('md-input', {
    attrs: {
      "placeholder": "进度",
      "type": "number"
    },
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  })], 1)], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog('cancel')
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog('confirm')
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 353:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cov-vue-date"
  }, [_c('div', {
    staticClass: "datepickbox",
    on: {
      "click": _vm.showCheck,
      "foucus": _vm.showCheck
    }
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.showInfo.check) ? _c('div', {
    staticClass: "datepicker-overlay",
    style: ({
      'background': _vm.option.overlayOpacity ? 'rgba(0,0,0,' + _vm.option.overlayOpacity + ')' : 'rgba(0,0,0,0.5)'
    }),
    on: {
      "click": function($event) {
        _vm.dismiss($event)
      }
    }
  }, [_c('div', {
    staticClass: "cov-date-body",
    style: ({
      'background-color': _vm.option.color ? _vm.option.color.header : '#3f51b5'
    })
  }, [_c('div', {
    staticClass: "cov-date-monthly"
  }, [_c('div', {
    staticClass: "cov-date-previous",
    on: {
      "click": function($event) {
        _vm.nextMonth('pre')
      }
    }
  }, [_vm._v("«")]), _vm._v(" "), _c('div', {
    staticClass: "cov-date-caption",
    style: ({
      'color': _vm.option.color ? _vm.option.color.headerText : '#fff'
    })
  }, [_c('span', {
    on: {
      "click": _vm.showYear
    }
  }, [_c('small', [_vm._v(_vm._s(_vm.checked.year))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.showMonth
    }
  }, [_vm._v(_vm._s(_vm.displayInfo.month))])]), _vm._v(" "), _c('div', {
    staticClass: "cov-date-next",
    on: {
      "click": function($event) {
        _vm.nextMonth('next')
      }
    }
  }, [_vm._v("»")])]), _vm._v(" "), (_vm.showInfo.day) ? _c('div', {
    staticClass: "cov-date-box"
  }, [_c('div', {
    staticClass: "cov-picker-box"
  }, [_c('div', {
    staticClass: "week"
  }, [_c('ul', _vm._l((_vm.library.week), function(weekie) {
    return _c('li', [_vm._v(_vm._s(weekie))])
  }))]), _vm._v(" "), _vm._l((_vm.dayList), function(day) {
    return _c('div', {
      staticClass: "day",
      class: {
        'checked': day.checked, 'unavailable': day.unavailable, 'passive-day': !(day.inMonth)
      },
      style: (day.checked ? (_vm.option.color && _vm.option.color.checkedDay ? {
        background: _vm.option.color.checkedDay
      } : {
        background: '#F50057'
      }) : {}),
      attrs: {
        "track-by": "$index"
      },
      on: {
        "click": function($event) {
          _vm.checkDay(day)
        }
      }
    }, [_vm._v(_vm._s(day.value))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.showInfo.year) ? _c('div', {
    staticClass: "cov-date-box list-box"
  }, [_c('div', {
    staticClass: "cov-picker-box date-list",
    attrs: {
      "id": "yearList"
    }
  }, _vm._l((_vm.library.year), function(yearItem) {
    return _c('div', {
      staticClass: "date-item",
      attrs: {
        "track-by": "$index"
      },
      on: {
        "click": function($event) {
          _vm.setYear(yearItem)
        }
      }
    }, [_vm._v(_vm._s(yearItem))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.showInfo.month) ? _c('div', {
    staticClass: "cov-date-box list-box"
  }, [_c('div', {
    staticClass: "cov-picker-box date-list"
  }, _vm._l((_vm.library.month), function(monthItem) {
    return _c('div', {
      staticClass: "date-item",
      attrs: {
        "track-by": "$index"
      },
      on: {
        "click": function($event) {
          _vm.setMonth(monthItem)
        }
      }
    }, [_vm._v(_vm._s(monthItem))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.showInfo.hour) ? _c('div', {
    staticClass: "cov-date-box list-box"
  }, [_c('div', {
    staticClass: "cov-picker-box date-list"
  }, [_c('div', {
    staticClass: "watch-box"
  }, [_c('div', {
    staticClass: "hour-box"
  }, [_c('div', {
    staticClass: "mui-pciker-rule mui-pciker-rule-ft"
  }), _vm._v(" "), _c('ul', _vm._l((_vm.hours), function(hitem) {
    return _c('li', {
      staticClass: "hour-item",
      class: {
        'active': hitem.checked
      },
      on: {
        "click": function($event) {
          _vm.setTime('hour', hitem, _vm.hours)
        }
      }
    }, [_vm._v(_vm._s(hitem.value))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "min-box"
  }, [_c('div', {
    staticClass: "mui-pciker-rule mui-pciker-rule-ft"
  }), _vm._v(" "), _vm._l((_vm.mins), function(mitem) {
    return _c('div', {
      staticClass: "min-item",
      class: {
        'active': mitem.checked
      },
      on: {
        "click": function($event) {
          _vm.setTime('min', mitem, _vm.mins)
        }
      }
    }, [_vm._v(_vm._s(mitem.value))])
  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-box"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.showInfo.check = false
      }
    }
  }, [_vm._v(_vm._s(_vm.option.buttons ? _vm.option.buttons.cancel : 'Cancel'))]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.picked
    }
  }, [_vm._v(_vm._s(_vm.option.buttons ? _vm.option.buttons.ok : 'Ok'))])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "todo-type-toggle"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.isTodoSquare = !_vm.isTodoSquare
      }
    }
  }, [_vm._v(_vm._s(_vm.isTodoSquare ? '切换到列表' : '切换到四象限'))])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isTodoSquare),
      expression: "!isTodoSquare"
    }],
    staticClass: "todo-list-table"
  }, [_c('div', {
    staticClass: "todo-group"
  }, [_c('transition-group', {
    attrs: {
      "name": "todo-list",
      "mode": "out-in"
    }
  }, _vm._l((_vm.todoFilter), function(todo) {
    return _c('md-whiteframe', {
      key: todo.id,
      staticClass: "todo-item",
      attrs: {
        "md-elevation": "1"
      },
      nativeOn: {
        "mouseover": function($event) {
          _vm.selectedOne = todo.id
        },
        "mouseout": function($event) {
          _vm.selectedOne = ''
        }
      }
    }, [_c('div', {
      staticClass: "todo-content"
    }, [_c('md-checkbox', {
      attrs: {
        "id": "my-test1",
        "name": "my-test1"
      },
      on: {
        "change": function($event) {
          _vm.completeTodo(todo.id, todo.isCompleted)
        }
      },
      model: {
        value: (todo.isCompleted),
        callback: function($$v) {
          todo.isCompleted = $$v
        },
        expression: "todo.isCompleted"
      }
    }, [_vm._v(" " + _vm._s(todo.text))]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "todo-icon"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selectedOne == todo.id),
        expression: "selectedOne==todo.id"
      }],
      staticClass: "todo-control"
    }, [_c('md-icon', {
      staticClass: "todo-delete",
      nativeOn: {
        "click": function($event) {
          _vm.removeTodo(todo.id)
        }
      }
    }, [_vm._v("delete")]), _vm._v(" "), _c('span', {
      staticClass: "todo-to-tomato",
      on: {
        "click": function($event) {
          _vm.redirectToTomato(todo)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(317)
      }
    })])], 1)])], 1)])
  }))], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowTodoInput),
      expression: "!isShowTodoInput"
    }],
    staticClass: "todo-add-tip tip-task",
    on: {
      "click": _vm.showTodoInput
    }
  }, [_c('md-icon', {
    staticClass: "md-accent"
  }, [_vm._v("add")]), _vm._v(" "), _c('span', [_vm._v("添加任务")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowTodoInput),
      expression: "isShowTodoInput"
    }],
    staticClass: "input-area"
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', [_c('md-input-container', [_c('md-input', {
    attrs: {
      "placeholder": "添加任务"
    },
    model: {
      value: (_vm.todoInputVal),
      callback: function($$v) {
        _vm.todoInputVal = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "todoInputVal"
    }
  })], 1), _vm._v(" "), _c('div', [_c('md-radio', {
    attrs: {
      "id": "level1",
      "name": "my-test-group1",
      "md-value": "1"
    },
    model: {
      value: (_vm.todoPriority),
      callback: function($$v) {
        _vm.todoPriority = $$v
      },
      expression: "todoPriority"
    }
  }, [_vm._v("紧急且重要")]), _vm._v(" "), _c('md-radio', {
    staticClass: "md-warn",
    attrs: {
      "name": "my-test-group1",
      "md-value": "2"
    },
    model: {
      value: (_vm.todoPriority),
      callback: function($$v) {
        _vm.todoPriority = $$v
      },
      expression: "todoPriority"
    }
  }, [_vm._v("重要但不紧急")]), _vm._v(" "), _c('md-radio', {
    staticClass: "md-primary",
    attrs: {
      "name": "my-test-group1",
      "md-value": "3"
    },
    model: {
      value: (_vm.todoPriority),
      callback: function($$v) {
        _vm.todoPriority = $$v
      },
      expression: "todoPriority"
    }
  }, [_vm._v("紧急但不重要")]), _vm._v(" "), _c('md-radio', {
    attrs: {
      "id": "level4",
      "name": "my-test-group1",
      "md-value": "4"
    },
    model: {
      value: (_vm.todoPriority),
      callback: function($$v) {
        _vm.todoPriority = $$v
      },
      expression: "todoPriority"
    }
  }, [_vm._v("不紧急且不重要")])], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button md-raised md-primary add-btn",
    attrs: {
      "disabled": _vm.todoInputVal.length === 0
    },
    nativeOn: {
      "click": function($event) {
        _vm.addTodo($event)
      }
    }
  }, [_c('md-icon', [_vm._v("add")])], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isTodoSquare),
      expression: "isTodoSquare"
    }]
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-whiteframe', {
    staticClass: "todo-square todo-urgent-important ",
    attrs: {
      "md-elevation": "4"
    }
  }, [_c('md-whiteframe', {
    staticClass: "todo-square-title",
    attrs: {
      "md-elevation": "1"
    }
  }, [_c('md-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.squareType !== 'iAndU'),
      expression: "squareType!=='iAndU'"
    }],
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('div', [_vm._v("紧急且重要")])]), _vm._v(" "), _c('md-layout', {
    nativeOn: {
      "click": function($event) {
        _vm.squareType = 'iAndU'
      }
    }
  }, [_c('md-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('md-input-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.squareType === 'iAndU'),
      expression: "squareType==='iAndU'"
    }],
    staticClass: "square-add-todo"
  }, [_c('md-input', {
    attrs: {
      "placeholder": "输入完成按回车添加"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.addTodo(1)
      }
    },
    model: {
      value: (_vm.todoInputVal),
      callback: function($$v) {
        _vm.todoInputVal = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "todoInputVal"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "todo-square-list"
  }, _vm._l((_vm.urgentAndImportantTodos), function(todo) {
    return _c('div', {
      key: todo.id,
      staticClass: "todo-content"
    }, [_c('md-checkbox', {
      attrs: {
        "id": "my-test1",
        "name": "my-test1"
      },
      on: {
        "change": function($event) {
          _vm.completeTodo(todo.id, todo.isCompleted)
        }
      },
      model: {
        value: (todo.isCompleted),
        callback: function($$v) {
          todo.isCompleted = $$v
        },
        expression: "todo.isCompleted"
      }
    }, [_vm._v(" " + _vm._s(todo.text))]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "todo-icon"
      }
    }, [_c('md-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selectedOne == todo.id),
        expression: "selectedOne==todo.id"
      }],
      staticClass: "todo-delete",
      nativeOn: {
        "click": function($event) {
          _vm.removeTodo(todo.id)
        }
      }
    }, [_vm._v("delete")])], 1)], 1)
  }))], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-whiteframe', {
    staticClass: "todo-square todo-noturgent-important",
    attrs: {
      "md-elevation": "4"
    }
  }, [_c('md-whiteframe', {
    staticClass: "todo-square-title",
    attrs: {
      "md-elevation": "1"
    }
  }, [_c('md-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.squareType !== 'notIButU'),
      expression: "squareType!=='notIButU'"
    }],
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('div', [_vm._v("紧急但不重要")])]), _vm._v(" "), _c('md-layout', {
    nativeOn: {
      "click": function($event) {
        _vm.squareType = 'notIButU'
      }
    }
  }, [_c('md-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('md-input-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.squareType === 'notIButU'),
      expression: "squareType==='notIButU'"
    }],
    staticClass: "square-add-todo"
  }, [_c('md-input', {
    attrs: {
      "placeholder": "输入完成按回车添加"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.addTodo(2)
      }
    },
    model: {
      value: (_vm.todoInputVal),
      callback: function($$v) {
        _vm.todoInputVal = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "todoInputVal"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "todo-square-list"
  }, _vm._l((_vm.urgentAndNotImportantTodos), function(todo) {
    return _c('div', {
      key: todo.id,
      staticClass: "todo-content"
    }, [_c('md-checkbox', {
      attrs: {
        "id": "my-test1",
        "name": "my-test1"
      },
      on: {
        "change": function($event) {
          _vm.completeTodo(todo.id, todo.isCompleted)
        }
      },
      model: {
        value: (todo.isCompleted),
        callback: function($$v) {
          todo.isCompleted = $$v
        },
        expression: "todo.isCompleted"
      }
    }, [_vm._v(" " + _vm._s(todo.text))]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "todo-icon"
      }
    }, [_c('md-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selectedOne == todo.id),
        expression: "selectedOne==todo.id"
      }],
      staticClass: "todo-delete",
      nativeOn: {
        "click": function($event) {
          _vm.removeTodo(todo.id)
        }
      }
    }, [_vm._v("delete")])], 1)], 1)
  }))], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-whiteframe', {
    staticClass: "todo-square todo-urgent-notimportant",
    attrs: {
      "md-elevation": "4"
    }
  }, [_c('md-whiteframe', {
    staticClass: "todo-square-title",
    attrs: {
      "md-elevation": "1"
    }
  }, [_c('md-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.squareType !== 'IButNotU'),
      expression: "squareType!=='IButNotU'"
    }],
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('div', [_vm._v("重要但不紧急")])]), _vm._v(" "), _c('md-layout', {
    nativeOn: {
      "click": function($event) {
        _vm.squareType = 'IButNotU'
      }
    }
  }, [_c('md-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('md-input-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.squareType === 'IButNotU'),
      expression: "squareType==='IButNotU'"
    }],
    staticClass: "square-add-todo"
  }, [_c('md-input', {
    attrs: {
      "placeholder": "输入完成按回车添加"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.addTodo(3)
      }
    },
    model: {
      value: (_vm.todoInputVal),
      callback: function($$v) {
        _vm.todoInputVal = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "todoInputVal"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "todo-square-list"
  }, _vm._l((_vm.notUrgentAndImportantTodos), function(todo) {
    return _c('div', {
      key: todo.id,
      staticClass: "todo-content"
    }, [_c('md-checkbox', {
      attrs: {
        "id": "my-test1",
        "name": "my-test1"
      },
      on: {
        "change": function($event) {
          _vm.completeTodo(todo.id, todo.isCompleted)
        }
      },
      model: {
        value: (todo.isCompleted),
        callback: function($$v) {
          todo.isCompleted = $$v
        },
        expression: "todo.isCompleted"
      }
    }, [_vm._v(" " + _vm._s(todo.text))]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "todo-icon"
      }
    }, [_c('md-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selectedOne == todo.id),
        expression: "selectedOne==todo.id"
      }],
      staticClass: "todo-delete",
      nativeOn: {
        "click": function($event) {
          _vm.removeTodo(todo.id)
        }
      }
    }, [_vm._v("delete")])], 1)], 1)
  }))], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-whiteframe', {
    staticClass: "todo-square todo-noturgent-notimportant",
    attrs: {
      "md-elevation": "4"
    }
  }, [_c('md-whiteframe', {
    staticClass: "todo-square-title",
    attrs: {
      "md-elevation": "1"
    }
  }, [_c('md-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.squareType !== 'notIAndNotU'),
      expression: "squareType!=='notIAndNotU'"
    }],
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('div', [_vm._v("不紧急且不重要")])]), _vm._v(" "), _c('md-layout', {
    nativeOn: {
      "click": function($event) {
        _vm.squareType = 'notIAndNotU'
      }
    }
  }, [_c('md-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('md-input-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.squareType === 'notIAndNotU'),
      expression: "squareType==='notIAndNotU'"
    }],
    staticClass: "square-add-todo"
  }, [_c('md-input', {
    attrs: {
      "placeholder": "输入完成按回车添加"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.addTodo(4)
      }
    },
    model: {
      value: (_vm.todoInputVal),
      callback: function($$v) {
        _vm.todoInputVal = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "todoInputVal"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "todo-square-list"
  }, _vm._l((_vm.notUrgentAndNotImportantTodos), function(todo) {
    return _c('div', {
      key: todo.id,
      staticClass: "todo-content"
    }, [_c('md-checkbox', {
      attrs: {
        "id": "my-test1",
        "name": "my-test1"
      },
      on: {
        "change": function($event) {
          _vm.completeTodo(todo.id, todo.isCompleted)
        }
      },
      model: {
        value: (todo.isCompleted),
        callback: function($$v) {
          todo.isCompleted = $$v
        },
        expression: "todo.isCompleted"
      }
    }, [_vm._v(" " + _vm._s(todo.text))]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "todo-icon"
      }
    }, [_c('md-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selectedOne == todo.id),
        expression: "selectedOne==todo.id"
      }],
      staticClass: "todo-delete",
      nativeOn: {
        "click": function($event) {
          _vm.removeTodo(todo.id)
        }
      }
    }, [_vm._v("delete")])], 1)], 1)
  }))], 1)], 1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "todo-header"
  }, [_c('span', {
    staticClass: "todo-header-day"
  }, [_vm._v("今天")]), _vm._v(" "), _c('span', {
    staticClass: "todo-header-date"
  }, [_vm._v("星期六 5月6日")])])
}]}

/***/ }),

/***/ 355:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-whiteframe', {
    staticClass: "plugin-nav",
    attrs: {
      "md-elevation": "2"
    }
  }, [_c('md-list', {
    style: ({
      height: _vm.navHeight + 'px'
    })
  }, _vm._l((_vm.plugins), function(plugin) {
    return _c('md-list-item', {
      key: plugin.id
    }, [_c('router-link', {
      attrs: {
        "to": plugin.link
      }
    }, [_c('md-icon', [_vm._v(_vm._s(plugin.icon))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(plugin.name))])], 1)], 1)
  }))], 1)], 1), _vm._v(" "), _c('md-layout', [_c('div', {
    staticClass: "plugin-container"
  }, [_c('router-view')], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 356:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline-item"
  }, [_c('div', {
    staticClass: "timeline-item-station"
  }), _vm._v(" "), _c('div', {
    staticClass: "timeline-item-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 357:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pie-chart"
  })
},staticRenderFns: []}

/***/ }),

/***/ 358:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cov-vue-date"
  }, [_c('div', {
    staticClass: "datepickbox",
    on: {
      "click": _vm.showCheck,
      "foucus": _vm.showCheck
    }
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.showInfo.check) ? _c('div', {
    staticClass: "datepicker-overlay",
    style: ({
      'background': _vm.option.overlayOpacity ? 'rgba(0,0,0,' + _vm.option.overlayOpacity + ')' : 'rgba(0,0,0,0.5)'
    }),
    on: {
      "click": function($event) {
        _vm.dismiss($event)
      }
    }
  }, [_c('div', {
    staticClass: "cov-date-body",
    style: ({
      'background-color': _vm.option.color ? _vm.option.color.header : '#3f51b5'
    })
  }, [_c('div', {
    staticClass: "cov-date-monthly"
  }, [_c('div', {
    staticClass: "cov-date-previous",
    on: {
      "click": function($event) {
        _vm.nextMonth('pre')
      }
    }
  }, [_vm._v("«")]), _vm._v(" "), _c('div', {
    staticClass: "cov-date-caption",
    style: ({
      'color': _vm.option.color ? _vm.option.color.headerText : '#fff'
    })
  }, [_c('span', {
    on: {
      "click": _vm.showYear
    }
  }, [_c('small', [_vm._v(_vm._s(_vm.checked.year))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.showMonth
    }
  }, [_vm._v(_vm._s(_vm.displayInfo.month))])]), _vm._v(" "), _c('div', {
    staticClass: "cov-date-next",
    on: {
      "click": function($event) {
        _vm.nextMonth('next')
      }
    }
  }, [_vm._v("»")])]), _vm._v(" "), (_vm.showInfo.day) ? _c('div', {
    staticClass: "cov-date-box"
  }, [_c('div', {
    staticClass: "cov-picker-box"
  }, [_c('div', {
    staticClass: "week"
  }, [_c('ul', _vm._l((_vm.library.week), function(weekie) {
    return _c('li', [_vm._v(_vm._s(weekie))])
  }))]), _vm._v(" "), _vm._l((_vm.dayList), function(day) {
    return _c('div', {
      staticClass: "day",
      class: {
        'checked': day.checked, 'unavailable': day.unavailable, 'passive-day': !(day.inMonth)
      },
      style: (day.checked ? (_vm.option.color && _vm.option.color.checkedDay ? {
        background: _vm.option.color.checkedDay
      } : {
        background: '#F50057'
      }) : {}),
      attrs: {
        "track-by": "$index"
      },
      on: {
        "click": function($event) {
          _vm.checkDay(day)
        }
      }
    }, [_vm._v(_vm._s(day.value))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.showInfo.year) ? _c('div', {
    staticClass: "cov-date-box list-box"
  }, [_c('div', {
    staticClass: "cov-picker-box date-list",
    attrs: {
      "id": "yearList"
    }
  }, _vm._l((_vm.library.year), function(yearItem) {
    return _c('div', {
      staticClass: "date-item",
      attrs: {
        "track-by": "$index"
      },
      on: {
        "click": function($event) {
          _vm.setYear(yearItem)
        }
      }
    }, [_vm._v(_vm._s(yearItem))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.showInfo.month) ? _c('div', {
    staticClass: "cov-date-box list-box"
  }, [_c('div', {
    staticClass: "cov-picker-box date-list"
  }, _vm._l((_vm.library.month), function(monthItem) {
    return _c('div', {
      staticClass: "date-item",
      attrs: {
        "track-by": "$index"
      },
      on: {
        "click": function($event) {
          _vm.setMonth(monthItem)
        }
      }
    }, [_vm._v(_vm._s(monthItem))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.showInfo.hour) ? _c('div', {
    staticClass: "cov-date-box list-box"
  }, [_c('div', {
    staticClass: "cov-picker-box date-list"
  }, [_c('div', {
    staticClass: "watch-box"
  }, [_c('div', {
    staticClass: "hour-box"
  }, [_c('div', {
    staticClass: "mui-pciker-rule mui-pciker-rule-ft"
  }), _vm._v(" "), _c('ul', _vm._l((_vm.hours), function(hitem) {
    return _c('li', {
      staticClass: "hour-item",
      class: {
        'active': hitem.checked
      },
      on: {
        "click": function($event) {
          _vm.setTime('hour', hitem, _vm.hours)
        }
      }
    }, [_vm._v(_vm._s(hitem.value))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "min-box"
  }, [_c('div', {
    staticClass: "mui-pciker-rule mui-pciker-rule-ft"
  }), _vm._v(" "), _vm._l((_vm.mins), function(mitem) {
    return _c('div', {
      staticClass: "min-item",
      class: {
        'active': mitem.checked
      },
      on: {
        "click": function($event) {
          _vm.setTime('min', mitem, _vm.mins)
        }
      }
    }, [_vm._v(_vm._s(mitem.value))])
  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-box"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.showInfo.check = false
      }
    }
  }, [_vm._v(_vm._s(_vm.option.buttons ? _vm.option.buttons.cancel : 'Cancel'))]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.picked
    }
  }, [_vm._v(_vm._s(_vm.option.buttons ? _vm.option.buttons.ok : 'Ok'))])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 359:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vue-map', {
    attrs: {
      "map": _vm.map
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 360:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "markdown-container",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Textarea")]), _vm._v(" "), _c('md-textarea', {
    staticClass: "markdown-textarea",
    model: {
      value: (_vm.mdVal),
      callback: function($$v) {
        _vm.mdVal = $$v
      },
      expression: "mdVal"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "parse-container",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.htmlVal)
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 363:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 364:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 365:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 366:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 367:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 368:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 369:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 370:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 371:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 372:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 373:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 374:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 375:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 376:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 377:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 378:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 379:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 380:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 381:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 382:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 383:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 384:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 385:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 109,
	"./af.js": 109,
	"./ar": 116,
	"./ar-dz": 110,
	"./ar-dz.js": 110,
	"./ar-kw": 111,
	"./ar-kw.js": 111,
	"./ar-ly": 112,
	"./ar-ly.js": 112,
	"./ar-ma": 113,
	"./ar-ma.js": 113,
	"./ar-sa": 114,
	"./ar-sa.js": 114,
	"./ar-tn": 115,
	"./ar-tn.js": 115,
	"./ar.js": 116,
	"./az": 117,
	"./az.js": 117,
	"./be": 118,
	"./be.js": 118,
	"./bg": 119,
	"./bg.js": 119,
	"./bn": 120,
	"./bn.js": 120,
	"./bo": 121,
	"./bo.js": 121,
	"./br": 122,
	"./br.js": 122,
	"./bs": 123,
	"./bs.js": 123,
	"./ca": 124,
	"./ca.js": 124,
	"./cs": 125,
	"./cs.js": 125,
	"./cv": 126,
	"./cv.js": 126,
	"./cy": 127,
	"./cy.js": 127,
	"./da": 128,
	"./da.js": 128,
	"./de": 131,
	"./de-at": 129,
	"./de-at.js": 129,
	"./de-ch": 130,
	"./de-ch.js": 130,
	"./de.js": 131,
	"./dv": 132,
	"./dv.js": 132,
	"./el": 133,
	"./el.js": 133,
	"./en-au": 134,
	"./en-au.js": 134,
	"./en-ca": 135,
	"./en-ca.js": 135,
	"./en-gb": 136,
	"./en-gb.js": 136,
	"./en-ie": 137,
	"./en-ie.js": 137,
	"./en-nz": 138,
	"./en-nz.js": 138,
	"./eo": 139,
	"./eo.js": 139,
	"./es": 141,
	"./es-do": 140,
	"./es-do.js": 140,
	"./es.js": 141,
	"./et": 142,
	"./et.js": 142,
	"./eu": 143,
	"./eu.js": 143,
	"./fa": 144,
	"./fa.js": 144,
	"./fi": 145,
	"./fi.js": 145,
	"./fo": 146,
	"./fo.js": 146,
	"./fr": 149,
	"./fr-ca": 147,
	"./fr-ca.js": 147,
	"./fr-ch": 148,
	"./fr-ch.js": 148,
	"./fr.js": 149,
	"./fy": 150,
	"./fy.js": 150,
	"./gd": 151,
	"./gd.js": 151,
	"./gl": 152,
	"./gl.js": 152,
	"./gom-latn": 153,
	"./gom-latn.js": 153,
	"./he": 154,
	"./he.js": 154,
	"./hi": 155,
	"./hi.js": 155,
	"./hr": 156,
	"./hr.js": 156,
	"./hu": 157,
	"./hu.js": 157,
	"./hy-am": 158,
	"./hy-am.js": 158,
	"./id": 159,
	"./id.js": 159,
	"./is": 160,
	"./is.js": 160,
	"./it": 161,
	"./it.js": 161,
	"./ja": 162,
	"./ja.js": 162,
	"./jv": 163,
	"./jv.js": 163,
	"./ka": 164,
	"./ka.js": 164,
	"./kk": 165,
	"./kk.js": 165,
	"./km": 166,
	"./km.js": 166,
	"./kn": 167,
	"./kn.js": 167,
	"./ko": 168,
	"./ko.js": 168,
	"./ky": 169,
	"./ky.js": 169,
	"./lb": 170,
	"./lb.js": 170,
	"./lo": 171,
	"./lo.js": 171,
	"./lt": 172,
	"./lt.js": 172,
	"./lv": 173,
	"./lv.js": 173,
	"./me": 174,
	"./me.js": 174,
	"./mi": 175,
	"./mi.js": 175,
	"./mk": 176,
	"./mk.js": 176,
	"./ml": 177,
	"./ml.js": 177,
	"./mr": 178,
	"./mr.js": 178,
	"./ms": 180,
	"./ms-my": 179,
	"./ms-my.js": 179,
	"./ms.js": 180,
	"./my": 181,
	"./my.js": 181,
	"./nb": 182,
	"./nb.js": 182,
	"./ne": 183,
	"./ne.js": 183,
	"./nl": 185,
	"./nl-be": 184,
	"./nl-be.js": 184,
	"./nl.js": 185,
	"./nn": 186,
	"./nn.js": 186,
	"./pa-in": 187,
	"./pa-in.js": 187,
	"./pl": 188,
	"./pl.js": 188,
	"./pt": 190,
	"./pt-br": 189,
	"./pt-br.js": 189,
	"./pt.js": 190,
	"./ro": 191,
	"./ro.js": 191,
	"./ru": 192,
	"./ru.js": 192,
	"./sd": 193,
	"./sd.js": 193,
	"./se": 194,
	"./se.js": 194,
	"./si": 195,
	"./si.js": 195,
	"./sk": 196,
	"./sk.js": 196,
	"./sl": 197,
	"./sl.js": 197,
	"./sq": 198,
	"./sq.js": 198,
	"./sr": 200,
	"./sr-cyrl": 199,
	"./sr-cyrl.js": 199,
	"./sr.js": 200,
	"./ss": 201,
	"./ss.js": 201,
	"./sv": 202,
	"./sv.js": 202,
	"./sw": 203,
	"./sw.js": 203,
	"./ta": 204,
	"./ta.js": 204,
	"./te": 205,
	"./te.js": 205,
	"./tet": 206,
	"./tet.js": 206,
	"./th": 207,
	"./th.js": 207,
	"./tl-ph": 208,
	"./tl-ph.js": 208,
	"./tlh": 209,
	"./tlh.js": 209,
	"./tr": 210,
	"./tr.js": 210,
	"./tzl": 211,
	"./tzl.js": 211,
	"./tzm": 213,
	"./tzm-latn": 212,
	"./tzm-latn.js": 212,
	"./tzm.js": 213,
	"./uk": 214,
	"./uk.js": 214,
	"./ur": 215,
	"./ur.js": 215,
	"./uz": 217,
	"./uz-latn": 216,
	"./uz-latn.js": 216,
	"./uz.js": 217,
	"./vi": 218,
	"./vi.js": 218,
	"./x-pseudo": 219,
	"./x-pseudo.js": 219,
	"./yo": 220,
	"./yo.js": 220,
	"./zh-cn": 221,
	"./zh-cn.js": 221,
	"./zh-hk": 222,
	"./zh-hk.js": 222,
	"./zh-tw": 223,
	"./zh-tw.js": 223
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 386;

/***/ }),

/***/ 695:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Timeline__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Timeline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Timeline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TimelineItem__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TimelineItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TimelineItem__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__TimelineItem___default.a; });



/***/ }),

/***/ 696:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layout_Header__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layout_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_layout_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(108);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_4__components_layout_Header___default.a.name, __WEBPACK_IMPORTED_MODULE_4__components_layout_Header___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_material___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
});

/***/ }),

/***/ 697:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    required: false,
    date: {
      type: Object,
      required: true
    },
    option: {
      type: Object,
      default: function _default() {
        return {
          type: 'day',
          SundayFirst: false,
          week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
          month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
          format: 'YYYY-MM-DD',
          color: {
            checked: '#F50057',
            header: '#3f51b5',
            headerText: '#fff'
          },
          inputStyle: {
            'display': 'inline-block',
            'padding': '6px',
            'line-height': '22px',
            'font-size': '16px',
            'border': '2px solid #fff',
            'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
            'border-radius': '2px',
            'color': '#5F5F5F'
          },
          placeholder: 'when?',
          buttons: {
            ok: 'OK',
            cancel: 'Cancel'
          },
          overlayOpacity: 0.5,
          dismissible: true
        };
      }
    },
    limit: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    function hours() {
      var list = [];
      var hour = 24;
      while (hour > 0) {
        hour--;
        list.push({
          checked: false,
          value: hour < 10 ? '0' + hour : hour
        });
      }
      return list;
    }
    function mins() {
      var list = [];
      var min = 60;
      while (min > 0) {
        min--;
        list.push({
          checked: false,
          value: min < 10 ? '0' + min : min
        });
      }
      return list;
    }
    return {
      hours: hours(),
      mins: mins(),
      showInfo: {

        hour: false,
        day: false,
        month: false,
        year: false,
        check: false
      },
      displayInfo: {
        month: ''
      },
      library: {
        week: this.option.week,
        month: this.option.month,
        year: []
      },
      checked: {
        oldtime: '',
        currentMoment: null,
        year: '',
        month: '',
        day: '',
        hour: '00',
        min: '00'
      },
      dayList: [],
      selectedDays: []
    };
  },

  methods: {
    pad: function pad(n) {
      n = Math.floor(n);
      return n < 10 ? '0' + n : n;
    },
    nextMonth: function nextMonth(type) {
      var next = null;
      type === 'next' ? next = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).add(1, 'M') : next = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).add(-1, 'M');
      this.showDay(next);
    },
    showDay: function showDay(time) {
      if (time === undefined || !Date.parse(time)) {
        this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
      } else {
        this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(time, this.option.format);
      }
      this.showOne('day');
      this.checked.year = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).format('YYYY');
      this.checked.month = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).format('MM');
      this.checked.day = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).format('DD');
      this.displayInfo.month = this.library.month[__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).month()];
      var days = [];
      var currentMoment = this.checked.currentMoment;
      var firstDay = __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).date(1).day();

      var previousMonth = __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment);
      var nextMonth = __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment);
      nextMonth.add(1, 'months');
      previousMonth.subtract(1, 'months');
      var monthDays = __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).daysInMonth();
      var oldtime = this.checked.oldtime;
      for (var i = 1; i <= monthDays; ++i) {
        days.push({
          value: i,
          inMonth: true,
          unavailable: false,
          checked: false,
          moment: __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).date(i)
        });
        if (i === Math.ceil(__WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).format('D')) && __WEBPACK_IMPORTED_MODULE_2_moment___default()(oldtime, this.option.format).year() === __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).year() && __WEBPACK_IMPORTED_MODULE_2_moment___default()(oldtime, this.option.format).month() === __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).month()) {
          days[i - 1].checked = true;
        }
        this.checkBySelectDays(i, days);
      }
      if (firstDay === 0) firstDay = 7;
      for (var _i = 0; _i < firstDay - (this.option.SundayFirst ? 0 : 1); _i++) {
        var passiveDay = {
          value: previousMonth.daysInMonth() - _i,
          inMonth: false,
          action: 'previous',
          unavailable: false,
          checked: false,
          moment: __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).date(1).subtract(_i + 1, 'days')
        };
        days.unshift(passiveDay);
      }
      if (this.limit.length > 0) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.limit), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var li = _step.value;

            switch (li.type) {
              case 'fromto':
                days = this.limitFromTo(li, days);
                break;
              case 'weekday':
                days = this.limitWeekDay(li, days);
                break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      var passiveDaysAtFinal = 42 - days.length;
      for (var _i2 = 1; _i2 <= passiveDaysAtFinal; _i2++) {
        var _passiveDay = {
          value: _i2,
          inMonth: false,
          action: 'next',
          unavailable: false,
          checked: false,
          moment: __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).add(1, 'months').date(_i2)
        };
        days.push(_passiveDay);
      }
      this.dayList = days;
    },
    checkBySelectDays: function checkBySelectDays(d, days) {
      var _this = this;

      this.selectedDays.forEach(function (day) {
        if (_this.checked.year === __WEBPACK_IMPORTED_MODULE_2_moment___default()(day).format('YYYY') && _this.checked.month === __WEBPACK_IMPORTED_MODULE_2_moment___default()(day).format('MM') && d === Math.ceil(__WEBPACK_IMPORTED_MODULE_2_moment___default()(day).format('D'))) {
          days[d - 1].checked = true;
        }
      });
    },
    limitWeekDay: function limitWeekDay(limit, days) {
      days.map(function (day) {
        if (limit.available.indexOf(Math.floor(day.moment.format('d'))) === -1) {
          day.unavailable = true;
        }
      });
      return days;
    },
    limitFromTo: function limitFromTo(limit, days) {
      var _this2 = this;

      if (limit.from || limit.to) {
        days.map(function (day) {
          if (_this2.getLimitCondition(limit, day)) {
            day.unavailable = true;
          }
        });
      }
      return days;
    },
    getLimitCondition: function getLimitCondition(limit, day) {
      var tmpMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.year + '-' + this.pad(this.checked.month) + '-' + this.pad(day.value));
      if (limit.from && !limit.to) {
        return !tmpMoment.isAfter(limit.from);
      } else if (!limit.from && limit.to) {
        return !tmpMoment.isBefore(limit.to);
      } else {
        return !tmpMoment.isBetween(limit.from, limit.to);
      }
    },
    checkDay: function checkDay(obj) {
      if (obj.unavailable || obj.value === '') {
        return false;
      }
      if (!obj.inMonth) {
        this.nextMonth(obj.action);
      }
      if (this.option.type === 'day' || this.option.type === 'min') {
        this.dayList.forEach(function (x) {
          x.checked = false;
        });
        this.checked.day = this.pad(obj.value);
        obj.checked = true;
      } else {
        var day = this.pad(obj.value);
        var ctime = this.checked.year + '-' + this.checked.month + '-' + day;
        if (obj.checked === true) {
          obj.checked = false;
          this.selectedDays.$remove(ctime);
        } else {
          this.selectedDays.push(ctime);
          obj.checked = true;
        }
      }
      switch (this.option.type) {
        case 'day':
          this.picked();
          break;
        case 'min':
          this.showOne('hour');

          this.shiftActTime();
          break;
      }
    },
    showYear: function showYear() {
      var _this3 = this;

      var year = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).year();
      this.library.year = [];
      var yearTmp = [];
      for (var i = year - 100; i < year + 5; ++i) {
        yearTmp.push(i);
      }
      this.library.year = yearTmp;
      this.showOne('year');
      this.$nextTick(function () {
        var listDom = document.getElementById('yearList');
        listDom.scrollTop = listDom.scrollHeight - 100;
        _this3.addYear();
      });
    },
    showOne: function showOne(type) {
      switch (type) {
        case 'year':
          this.showInfo.hour = false;
          this.showInfo.day = false;
          this.showInfo.year = true;
          this.showInfo.month = false;
          break;
        case 'month':
          this.showInfo.hour = false;
          this.showInfo.day = false;
          this.showInfo.year = false;
          this.showInfo.month = true;
          break;
        case 'day':
          this.showInfo.hour = false;
          this.showInfo.day = true;
          this.showInfo.year = false;
          this.showInfo.month = false;
          break;
        case 'hour':
          this.showInfo.hour = true;
          this.showInfo.day = false;
          this.showInfo.year = false;
          this.showInfo.month = false;
          break;
        default:
          this.showInfo.day = true;
          this.showInfo.year = false;
          this.showInfo.month = false;
          this.showInfo.hour = false;
      }
    },
    showMonth: function showMonth() {
      this.showOne('month');
    },
    addYear: function addYear() {
      var _this4 = this;

      var listDom = document.getElementById('yearList');
      listDom.addEventListener('scroll', function (e) {
        if (listDom.scrollTop < listDom.scrollHeight - 100) {
          var len = _this4.library.year.length;
          var lastYear = _this4.library.year[len - 1];
          _this4.library.year.push(lastYear + 1);
        }
      }, false);
    },
    setYear: function setYear(year) {
      this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(year + '-' + this.checked.month + '-' + this.checked.day);
      this.showDay(this.checked.currentMoment);
    },
    setMonth: function setMonth(month) {
      var mo = this.library.month.indexOf(month) + 1;
      if (mo < 10) {
        mo = '0' + '' + mo;
      }
      this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.year + '-' + mo + '-' + this.checked.day);
      this.showDay(this.checked.currentMoment);
    },
    showCheck: function showCheck() {
      if (this.date.time === '') {
        this.showDay();
      } else {
        if (this.option.type === 'day' || this.option.type === 'min') {
          this.checked.oldtime = this.date.time;
          this.showDay(this.date.time);
        } else {
          this.selectedDays = JSON.parse(this.date.time);
          if (this.selectedDays.length) {
            this.checked.oldtime = this.selectedDays[0];
            this.showDay(this.selectedDays[0]);
          } else {
            this.showDay();
          }
        }
      }
      this.showInfo.check = true;
    },
    setTime: function setTime(type, obj, list) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          item.checked = false;
          if (item.value === obj.value) {
            item.checked = true;
            this.checked[type] = item.value;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    picked: function picked() {
      if (this.option.type === 'day' || this.option.type === 'min') {
        var ctime = this.checked.year + '-' + this.checked.month + '-' + this.checked.day + ' ' + this.checked.hour + ':' + this.checked.min;
        this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(ctime, 'YYYY-MM-DD HH:mm');
        this.date.time = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).format(this.option.format);
      } else {
        this.date.time = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedDays);
      }
      this.showInfo.check = false;
      this.$emit('change', this.date.time);
    },
    dismiss: function dismiss(evt) {
      if (evt.target.className === 'datepicker-overlay') {
        if (this.option.dismissible === undefined || this.option.dismissible) {
          this.showInfo.check = false;
          this.$emit('cancel');
        }
      }
    },
    shiftActTime: function shiftActTime() {
      this.$nextTick(function () {
        if (!document.querySelector('.hour-item.active')) {
          return false;
        }
        document.querySelector('.hour-box').scrollTop = (document.querySelector('.hour-item.active').offsetTop || 0) - 250;
        document.querySelector('.min-box').scrollTop = (document.querySelector('.min-item.active').offsetTop || 0) - 250;
      });
    }
  }
});

/***/ }),

/***/ 698:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 699:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PluginCard_vue__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PluginCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PluginCard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins__ = __webpack_require__(306);




var cards = __WEBPACK_IMPORTED_MODULE_1__plugins__["a" /* default */];
var cardColors = [{ top: '#3EC69A', bottom: '#3768BE' }, { top: '#2E7FBF', bottom: '#986BAD' }, { top: '#FFAE80', bottom: '#E15A84' }, { top: '#3EC69A', bottom: '#3768BE' }, { top: '#74D0F8', bottom: '#3A3377' }];
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {
      cards: cards,
      cardColors: cardColors
    };
  },

  components: {
    PluginCard: __WEBPACK_IMPORTED_MODULE_0__PluginCard_vue___default.a
  },
  methods: {
    goToPlugin: function goToPlugin(link) {
      this.$router.push('plugin/' + link);
    }
  }
});

/***/ }),

/***/ 700:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pluginCard',
  props: ['name', 'desc', 'bgColor'],
  data: function data() {
    return {
      cardStyle: {
        background: '-webkit-linear-gradient(left top,' + this.bgColor.top + ',' + this.bgColor.bottom + ')'
      }
    };
  }
});

/***/ }),

/***/ 701:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HeaderNav__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HeaderNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__HeaderNav__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Header',
  components: {
    HeaderNav: __WEBPACK_IMPORTED_MODULE_0__HeaderNav___default.a
  }
});

/***/ }),

/***/ 702:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'headerNav'
});

/***/ }),

/***/ 703:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid_v1__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid_v1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uuid_v1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tools_Timepicker_Timepicker__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tools_Timepicker_Timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_tools_Timepicker_Timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_localStorage__ = __webpack_require__(74);





var LOCAL_PLANS = 'LOCAL_PLAN';

var _local = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_localStorage__["a" /* default */])(LOCAL_PLANS),
    saveLocal = _local.saveLocal,
    getLocal = _local.getLocal,
    removeLocal = _local.removeLocal;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'annualPlan',
  data: function data() {
    return {
      plans: [],
      planContent: '',
      planDuration: '',
      planDeadline: '',
      startTime: {
        time: ''
      },
      endTime: {
        time: ''
      },
      editPlanObj: {
        id: '',
        content: '',
        startTime: {
          time: ''
        },
        endTime: {
          time: ''
        },
        progress: 0
      }
    };
  },
  created: function created() {
    this.plans = getLocal().plans || [];
  },

  methods: {
    addPlan: function addPlan() {
      this.plans.push({
        id: __WEBPACK_IMPORTED_MODULE_0_uuid_v1___default()(),
        content: this.planContent,
        startTime: this.startTime.time,
        endTime: this.endTime.time,
        progress: 0
      });
      this.savePlans();
    },
    removePlan: function removePlan(id) {
      this.plans = this.plans.filter(function (plan) {
        return plan.id !== id;
      });
      this.savePlans();
    },
    savePlans: function savePlans() {
      saveLocal({
        plans: this.plans
      });
    },
    editPlan: function editPlan(plan) {
      this.editPlanObj.id = plan.id;
      this.editPlanObj.content = plan.content;
      this.editPlanObj.startTime.time = plan.startTime;
      this.editPlanObj.endTime.time = plan.endTime;
      this.editPlanObj.progress = plan.progress;

      this.openDialog();
    },
    openDialog: function openDialog() {
      this.$refs.editPlanDialog.open();
    },
    closeDialog: function closeDialog(action) {
      if (action === 'confirm') {
        var _editPlanObj = this.editPlanObj,
            id = _editPlanObj.id,
            content = _editPlanObj.content,
            startTime = _editPlanObj.startTime,
            endTime = _editPlanObj.endTime,
            progress = _editPlanObj.progress;

        this.plans.forEach(function (plan) {
          if (plan.id === id) {
            plan.content = content;
            plan.startTime = startTime.time;
            plan.endTime = endTime.time;
            plan.progress = progress;
          }
        });
        this.savePlans();
      }
      this.$refs.editPlanDialog.close();
    },
    onOpen: function onOpen() {
      console.log('Opened');
    },
    onClose: function onClose(type) {
      console.log('Closed', type);
    }
  },
  components: {
    'date-picker': __WEBPACK_IMPORTED_MODULE_1__components_tools_Timepicker_Timepicker___default.a
  }
});

/***/ }),

/***/ 704:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_TimeLine__ = __webpack_require__(695);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'birthday',
  data: function data() {
    return {
      birthdays: [{
        id: __WEBPACK_IMPORTED_MODULE_0_uuid___default()(),
        date: '06/11',
        text: '杨建明',
        remark: '送他一个TT'
      }, {
        id: __WEBPACK_IMPORTED_MODULE_0_uuid___default()(),
        date: '12/22',
        text: '周悦',
        remark: '要买一份很有纪念意义的生日礼物'
      }, {
        id: __WEBPACK_IMPORTED_MODULE_0_uuid___default()(),
        date: '05/22',
        text: 'luke',
        remark: '要买一份很有纪念意义的生日礼物'
      }],
      nowDate: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('MM/DD'),
      personName: '',
      personTime: '',
      remark: '',
      isShowAnniversary: true,
      isShowFestival: true,
      togetherTime: ''
    };
  },

  computed: {
    birthdayList: function birthdayList() {
      return this.birthdays.sort(compareFunc);

      function compareFunc(prev, cur) {
        if (__WEBPACK_IMPORTED_MODULE_1_moment___default()(prev.date, 'MM/DD').isAfter(__WEBPACK_IMPORTED_MODULE_1_moment___default()(cur.date, 'MM/DD'))) {
          return 1;
        } else {
          return -1;
        }
      }
    }
  },
  methods: {
    openDialog: function openDialog() {
      this.$refs.addBirthdayDialog.open();
    },
    closeDialog: function closeDialog() {
      this.$refs.addBirthdayDialog.close();
    },
    toggleRightSidenav: function toggleRightSidenav() {
      this.$refs.rightSidenav.toggle();
    },
    saveSetting: function saveSetting() {
      this.$refs.rightSidenav.close();
    }
  },
  components: {
    TimeLine: __WEBPACK_IMPORTED_MODULE_2__tools_TimeLine__["a" /* TimeLine */],
    TimelineItem: __WEBPACK_IMPORTED_MODULE_2__tools_TimeLine__["b" /* TimelineItem */]
  }
});

/***/ }),

/***/ 705:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_tools_Book_Book__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_tools_Book_Book___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_tools_Book_Book__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uuid__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      books: [{
        id: __WEBPACK_IMPORTED_MODULE_1_uuid___default()(),
        name: '老人与海',
        author: '海明威',
        progress: 50
      }, {
        id: __WEBPACK_IMPORTED_MODULE_1_uuid___default()(),
        name: '老人与海',
        author: '海明威',
        progress: 50
      }, {
        id: __WEBPACK_IMPORTED_MODULE_1_uuid___default()(),
        name: '老人与海',
        author: '海明威',
        progress: 50
      }],
      bookName: '',
      bookAuthor: '',
      progress: ''
    };
  },

  methods: {
    addBook: function addBook() {
      this.openDialog();
    },
    openDialog: function openDialog() {
      this.$refs.addBookDialog.open();
    },
    closeDialog: function closeDialog() {
      this.$refs.addBookDialog.close();
    }
  },
  components: {
    Book: __WEBPACK_IMPORTED_MODULE_0__components_tools_Book_Book___default.a
  }
});

/***/ }),

/***/ 706:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Map__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Map__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dashboard',
  data: function data() {
    return {
      map: []
    };
  },
  created: function created() {
    console.log(collectMap(__WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].options.routes));
    console.log(__WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].options.routes);
    this.map = collectMap(__WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].options.routes);
  },

  components: {
    vueMap: __WEBPACK_IMPORTED_MODULE_2__Map___default.a
  }
});

function collectMap(components) {
  var map = [];

  var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(components);
  var len = keys.length;
  while (len--) {
    var item = components[keys[len]];
    var _Children = item.children || item.component && item.component.components;
    var children = void 0;
    if (_Children) {
      children = collectMap(_Children);
    }
    map.push({
      name: item.name,
      children: children || []
    });
  }
  return map;
}

/***/ }),

/***/ 707:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vueMap',
  render: function render(createElement) {
    function createLoop(val) {
      return val.map(function (item) {

        if (item.children.length > 0) {
          return createElement('div', { 'class': 'component-square' }, [createElement('div', { 'class': 'components-container' }, [createElement('span', { 'class': 'component-name' }, item.name)].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(createLoop(item.children))))]);
        } else {
          return createElement('div', { 'class': 'component-square' }, [createElement('span', { 'class': 'component-name' }, item.name)]);
        }
      });
    }
    return createElement('div', { 'class': 'components-container' }, createLoop(this.map));
  },

  props: ['map']
});

/***/ }),

/***/ 708:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_markdown__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_markdown__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'markdown',
  data: function data() {
    return {
      mdVal: '',
      htmlVal: ''
    };
  },

  watch: {
    mdVal: function mdVal(newVal) {
      this.htmlVal = __WEBPACK_IMPORTED_MODULE_0_markdown__["markdown"].toHTML(newVal);
    }
  }
});

/***/ }),

/***/ 709:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins__ = __webpack_require__(306);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'plugin',
  data: function data() {
    return {
      plugins: __WEBPACK_IMPORTED_MODULE_0__plugins__["a" /* default */],
      navHeight: 0
    };
  },
  created: function created() {
    this.navHeight = window.innerHeight - 150;
  }
});

/***/ }),

/***/ 710:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'random',
  data: function data() {
    return {
      randomVal: '',
      cards: [],
      seletedCardId: '',
      allShow: true
    };
  },

  computed: {
    randoms: function randoms() {
      var arr = this.randomVal.split('/');
      if (!arr[arr.length - 1]) arr.pop();
      return arr;
    }
  },
  created: function created() {},

  methods: {
    duang: function duang() {
      var _this = this;

      this.allShow = false;
      this.seletedCardId = '';
      this.cards = shuffle(this.cards);
      setTimeout(function () {
        _this.cards = shuffle(_this.cards);
      }, 1000);
    },
    splitRandomVal: function splitRandomVal() {
      this.cards = this.randoms.map(function (item, index) {
        return {
          id: index + 1,
          value: item
        };
      });
    }
  }
});
function shuffle(a) {
  for (var i = a.length; i; i--) {
    var j = Math.floor(Math.random() * i);
    var _ref = [a[j], a[i - 1]];
    a[i - 1] = _ref[0];
    a[j] = _ref[1];
  }
  return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(a));
}

/***/ }),

/***/ 711:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid_v1__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid_v1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid_v1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_localStorage__ = __webpack_require__(74);







var _local = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_localStorage__["a" /* default */])('rememberCurve'),
    saveLocal = _local.saveLocal,
    getLocal = _local.getLocal,
    removeLocal = _local.removeLocal;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rememberCurve',
  data: function data() {
    return {
      now: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format("YYYY-MM-DD"),
      rememberContent: '',
      remembers: [],
      timeline: {},
      todayRemember: '',
      tomorrowRemember: '',
      weekdays: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      currentMonth: __WEBPACK_IMPORTED_MODULE_1_moment___default()().month()
    };
  },
  created: function created() {
    this.getRemembers();
  },

  computed: {
    allRemeberDays: function allRemeberDays() {
      var now = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.now);
      var rememberDays = EbbinghausCurve(this.now);
      return rememberDays;
    },
    calendar: function calendar() {
      var currentMonthMoment = __WEBPACK_IMPORTED_MODULE_1_moment___default()().month(this.currentMonth);
      var month = __WEBPACK_IMPORTED_MODULE_1_moment___default()().month(this.currentMonth).month() + 1;
      var currentMonthDays = __WEBPACK_IMPORTED_MODULE_1_moment___default()().month(this.currentMonth).daysInMonth();
      var lastMonthDays = __WEBPACK_IMPORTED_MODULE_1_moment___default()().month(this.currentMonth).subtract(1, 'month').daysInMonth();
      var nextMonthDays = __WEBPACK_IMPORTED_MODULE_1_moment___default()().month(this.currentMonth).add(1, 'month').daysInMonth();
      var currentDay = +__WEBPACK_IMPORTED_MODULE_1_moment___default()().month(this.currentMonth).format('DD');
      var firstDayofCurrentMonthWeekDay = __WEBPACK_IMPORTED_MODULE_1_moment___default()().month(this.currentMonth).subtract(currentDay - 1, 'days').weekday();
      var lastDayofCurrentMonthWeekDay = __WEBPACK_IMPORTED_MODULE_1_moment___default()().month(this.currentMonth).add(currentMonthDays - currentDay, 'days').weekday();
      var days = [];

      for (var i = 1; i <= currentMonthDays; i++) {
        days.push({
          value: i,
          date: __WEBPACK_IMPORTED_MODULE_1_moment___default()().month(this.currentMonth).subtract(currentDay - i, 'days').format('YYYY-MM-DD')
        });
      }

      if (firstDayofCurrentMonthWeekDay > 1) {
        for (var _i = 0; _i < firstDayofCurrentMonthWeekDay - 1; _i++) {
          days.unshift({
            value: lastMonthDays - _i,
            date: __WEBPACK_IMPORTED_MODULE_1_moment___default()().month(this.currentMonth).subtract(currentDay + _i, 'days').format('YYYY-MM-DD')
          });
        }
      }
      if (lastDayofCurrentMonthWeekDay < 7) {
        for (var _i2 = 1; _i2 <= 7 - lastDayofCurrentMonthWeekDay; _i2++) {
          days.push({
            value: _i2,
            date: __WEBPACK_IMPORTED_MODULE_1_moment___default()().month(this.currentMonth).add(currentMonthDays - currentDay + _i2, 'days').format('YYYY-MM-DD')
          });
        }
      }
      console.log(__WEBPACK_IMPORTED_MODULE_1_moment___default()().days());

      return days;
    }
  },
  methods: {
    addRemeber: function addRemeber() {
      var now = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
      var data = {
        id: __WEBPACK_IMPORTED_MODULE_2_uuid_v1___default()(),
        rememberContent: this.rememberContent,
        rememberDays: EbbinghausCurve(now)
      };
      this.remembers.push(data);
      saveLocal({
        remembers: this.remembers
      });
      this.timeline = RemembersMerge(this.remembers);
    },
    getRemembers: function getRemembers() {
      var remembers = getLocal().remembers;
      if (!remembers) return;
      this.remembers = remembers;
      this.timeline = RemembersMerge(remembers);
      var today = __WEBPACK_IMPORTED_MODULE_1_moment___default()().format("YYYY-MM-DD");
      var tomorrow = __WEBPACK_IMPORTED_MODULE_1_moment___default()().add(1, 'days').format("YYYY-MM-DD");
      if (this.timeline[today]) {
        this.todayRemember = this.timeline[today];

        delete this.timeline[today];
      }
      if (this.timeline[tomorrow]) {
        this.tomorrowRemember = this.timeline[tomorrow];

        delete this.timeline[tomorrow];
      }
    },
    changeMonth: function changeMonth(action) {
      switch (action) {
        case 'next':
          this.currentMonth = this.currentMonth + 1;
          break;
        case 'last':
          this.currentMonth = this.currentMonth - 1;
          break;
        case 'now':
          this.currentMonth = __WEBPACK_IMPORTED_MODULE_1_moment___default()().month();
          break;
      }
    },
    chooseDay: function chooseDay(event, task) {}
  }
});
var curveDays = [{
  number: 0,
  type: 'days'
}, {
  number: 2,
  type: 'days'
}, {
  number: 4,
  type: 'days'
}, {
  number: 7,
  type: 'days'
}, {
  number: 15,
  type: 'days'
}, {
  number: 30,
  type: 'days'
}];

function EbbinghausCurve(currentDate) {
  var curveDates = curveDays.map(function (day) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(currentDate).add(day.number, day.type).format("YYYY-MM-DD");
  });
  return curveDates;
}

function RemembersMerge(arr) {
  var timeline = {};
  arr.forEach(function (remember) {
    var id = remember.id,
        rememberContent = remember.rememberContent;

    remember.rememberDays.forEach(function (item) {
      var temp = {
        id: id,
        rememberContent: rememberContent
      };
      timeline[item] = timeline[item] ? [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(timeline[item]), [temp]) : [temp];
    });
  });
  return timeline;
}

/***/ }),

/***/ 712:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid_v1__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid_v1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uuid_v1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tools_Echarts_Pie__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tools_Echarts_Pie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_tools_Echarts_Pie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_datepicker_vue_datepicker_es6__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_datepicker_vue_datepicker_es6___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_datepicker_vue_datepicker_es6__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_localStorage__ = __webpack_require__(74);









var _local = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_localStorage__["a" /* default */])('timenotes'),
    saveLocal = _local.saveLocal,
    getLocal = _local.getLocal,
    removeLocal = _local.removeLocal;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'timenote',
  data: function data() {
    return {
      isShowTimenoteInput: false,
      tag: '',
      childTag: '',
      timenotes: [],
      thingContentInputVal: '',
      thingTimeInputVal: '',
      selectedOne: '',
      selectedParentTag: {
        text: ''
      },
      hoverTagOne: '',
      isTimeInputErrorMsg: false,
      tags: [{
        id: __WEBPACK_IMPORTED_MODULE_1_uuid_v1___default()(),
        text: '工作'
      }, {
        id: __WEBPACK_IMPORTED_MODULE_1_uuid_v1___default()(),
        text: '学习'
      }, {
        id: __WEBPACK_IMPORTED_MODULE_1_uuid_v1___default()(),
        text: '运动'
      }, {
        id: __WEBPACK_IMPORTED_MODULE_1_uuid_v1___default()(),
        text: '休息'
      }],
      childTags: [],
      newTagVal: '',
      newChildTagVal: '',
      noteChooseDate: {
        time: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-mm-dd')
      },
      noteWeekday: '',
      noteDate: ''
    };
  },
  created: function created() {
    this.timenotes = this.getTimenotes() && this.getTimenotes();
    this.tags = this.getTags().length && this.getTags() || this.tags;
    this.noteWeekday = __WEBPACK_IMPORTED_MODULE_2_moment___default()().weekday();
    this.noteDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY年MM月DD日');
  },

  computed: {
    totalTime: function totalTime() {
      var totalTime = 0;
      this.timenotes.forEach(function (note) {
        return totalTime += parseInt(note.time);
      });
      return totalTime + 'h';
    },
    chartOption: function chartOption() {
      var totalTime = 0;
      var otherTime = {};
      var innerData = [];
      var outData = this.timenotes.map(function (note) {
        totalTime += +note.time;
        return {
          value: +note.time,
          name: note.text
        };
      });

      otherTime = computeTagTime(this.timenotes, 'tag');

      for (var key in otherTime) {
        innerData.push({
          value: otherTime[key],
          name: key
        });
      }

      if (totalTime < 24) {
        console.log(totalTime);
        outData.push({
          value: 24 - totalTime,
          name: '其他'
        });

        innerData.push({
          value: 24 - totalTime,
          name: '其他'
        });
      }

      var option = {
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b}: {c}小时 ({d}%)"
        },

        series: [{
          name: 'TimeNote',
          type: 'pie',
          selectedMode: 'single',
          radius: [0, '50%'],

          label: {
            normal: {
              position: 'inner'
            }
          },
          labelLine: {
            normal: {
              show: false
            }
          },
          data: innerData
        }, {
          name: '访问来源',
          type: 'pie',
          radius: ['60%', '75%'],

          data: outData
        }]
      };
      return option;
    }
  },
  methods: {
    showTimenoteInput: function showTimenoteInput() {
      this.isShowTimenoteInput = true;
    },
    addTimenote: function addTimenote() {
      var id = __WEBPACK_IMPORTED_MODULE_1_uuid_v1___default()();
      var newTimenote = {
        id: id,
        text: this.thingContentInputVal,
        time: this.thingTimeInputVal,
        tag: this.tag,
        childTag: this.childTag
      };
      this.thingContentInputVal = '';
      this.thingTimeInputVal = '';
      this.tag = '';
      this.childTag = '';
      this.timenotes.push(newTimenote);
      this.saveTimenotes();
    },
    removeTimenote: function removeTimenote(id) {
      this.timenotes = this.timenotes.filter(function (timenote) {
        return timenote.id !== id;
      });
      this.saveTimenotes();
    },
    getTimenotes: function getTimenotes() {
      var timenotes = getLocal() && getLocal().timenotes || [];
      return timenotes;
    },
    saveTimenotes: function saveTimenotes() {
      removeLocal();
      console.log(this.tags);
      saveLocal({
        timenotes: this.timenotes,
        tags: this.tags
      });
    },
    computeTime: function computeTime(type) {
      var totalTime = 0;
      this.timenotes.forEach(function (note) {
        return note.tag === type && (totalTime += parseInt(note.time));
      });
      return totalTime + 'h';
    },
    getTags: function getTags() {
      var tags = getLocal() && getLocal().tags || [];
      return tags;
    },
    addTag: function addTag() {
      var newTag = {
        id: __WEBPACK_IMPORTED_MODULE_1_uuid_v1___default()(),
        text: this.newTagVal,
        children: []
      };
      this.tags.push(newTag);
      this.saveTimenotes();
    },
    removeTag: function removeTag(id) {
      var filterTag = this.tags.filter(function (tag) {
        return tag.id !== id;
      });
      this.tags = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(filterTag));
      this.saveTimenotes();
    },
    toggleRightSidenav: function toggleRightSidenav() {
      this.$refs.rightSidenav.toggle();
    },
    closeRightSidenav: function closeRightSidenav() {
      this.$refs.rightSidenav.close();
    },
    open: function open(ref) {
      console.log('Opened: ' + ref);
    },
    close: function close(ref) {
      console.log('Closed: ' + ref);
    },
    dateChange: function dateChange(date) {
      var format = __WEBPACK_IMPORTED_MODULE_2_moment___default()(date, 'YYYY-MM-DD');
      this.noteWeekday = format.weekday();
      this.noteDate = format.format('YYYY年MM月DD日');
    },
    chooseDate: function chooseDate(day) {
      var format = void 0;
      switch (day) {
        case 'yesterday':
          format = __WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(1, 'days');
          this.noteWeekday = format.weekday();
          this.noteDate = format.format('YYYY年MM月DD日');
          break;
        case 'today':
          format = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
          this.noteWeekday = format.weekday();
          this.noteDate = format.format('YYYY年MM月DD日');
          break;
      }
    },
    chooseParentTag: function chooseParentTag(tag) {
      this.selectedParentTag = tag;
      this.newChildTagVal = '';
      this.childTags = tag.children || [];
    },
    addChildTag: function addChildTag() {
      var _this = this;

      this.tags.forEach(function (tag) {
        if (tag.id == _this.selectedParentTag.id) {
          if (!tag.children) tag.children = [];
          tag.children.push({
            text: _this.newChildTagVal,
            id: __WEBPACK_IMPORTED_MODULE_1_uuid_v1___default()()
          });
          _this.childTags = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(tag.children));
        }
      });
      this.saveTimenotes();
    },
    removeChildTag: function removeChildTag(tagId) {
      var _this2 = this;

      this.tags.forEach(function (tag) {
        if (tag.id == _this2.selectedParentTag.id) {
          _this2.childTags = _this2.childTags.filter(function (childTag) {
            return childTag.id !== tagId;
          });
          tag.children = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this2.childTags));
        }
      });
      this.saveTimenotes();
    }
  },
  watch: {
    thingTimeInputVal: function thingTimeInputVal(newVal) {
      console.log(this.isTimeInputErrorMsg);
      if (!newVal) return;
      if (newVal > 24) {
        this.thingTimeInputVal = '';
        this.isTimeInputErrorMsg = true;
      } else {
        this.isTimeInputErrorMsg = false;
      }
    }
  },
  components: {
    PieChart: __WEBPACK_IMPORTED_MODULE_3__components_tools_Echarts_Pie___default.a,
    'date-picker': __WEBPACK_IMPORTED_MODULE_4_vue_datepicker_vue_datepicker_es6___default.a
  }
});

function computeTagTime(data, key) {
  var tag = {};
  data.forEach(function (item) {
    if (!tag[item[key]]) {
      tag[item[key]] = +item.time;
    } else {
      tag[item[key]] += +item.time;
    }
  });
  return tag;
}

/***/ }),

/***/ 713:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid_v1__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid_v1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uuid_v1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_localStorage__ = __webpack_require__(74);





var _local = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_localStorage__["a" /* default */])('todos'),
    saveLocal = _local.saveLocal,
    getLocal = _local.getLocal,
    removeLocal = _local.removeLocal;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'todo',
  data: function data() {
    return {
      isShowTodoInput: false,
      todoPriority: 1,
      todos: [],
      todoInputVal: '',
      selectedOne: '',
      isTodoSquare: true,
      squareType: ''
    };
  },
  created: function created() {
    this.todos = this.getTodos() || [];
    console.log(this);
  },

  computed: {
    todoFilter: function todoFilter() {
      return this.todos.filter(function (todo) {
        return !todo.isCompleted;
      });
    },
    urgentAndImportantTodos: function urgentAndImportantTodos() {
      return this.todos.filter(function (todo) {
        return todo.priority == 1 && !todo.isCompleted;
      });
    },
    urgentAndNotImportantTodos: function urgentAndNotImportantTodos() {
      return this.todos.filter(function (todo) {
        return todo.priority == 2 && !todo.isCompleted;
      });
    },
    notUrgentAndImportantTodos: function notUrgentAndImportantTodos() {
      return this.todos.filter(function (todo) {
        return todo.priority == 3 && !todo.isCompleted;
      });
    },
    notUrgentAndNotImportantTodos: function notUrgentAndNotImportantTodos() {
      return this.todos.filter(function (todo) {
        return todo.priority == 4 && !todo.isCompleted;
      });
    }
  },
  methods: {
    showTodoInput: function showTodoInput() {
      this.isShowTodoInput = true;
    },
    addTodo: function addTodo(priority) {
      var todoText = this.todoInputVal;
      if (!todoText) return;

      var _ref = parseTodoText(todoText) || 1,
          text = _ref.text,
          duration = _ref.duration;

      var id = __WEBPACK_IMPORTED_MODULE_0_uuid_v1___default()();
      var newTodo = {
        id: id,
        text: text,
        priority: priority || this.todoPriority,
        isCompleted: false,

        duration: duration
      };
      this.todos.push(newTodo);
      this.todoInputVal = '', this.squareType = '';
      this.saveTodos();
    },
    removeTodo: function removeTodo(id) {
      this.todos = this.todos.filter(function (todo) {
        return todo.id !== id;
      });
      this.saveTodos();
    },
    editTodo: function editTodo() {},
    completeTodo: function completeTodo(id, isCompleted) {

      this.squareType && (this.squareType = '');

      if (!isCompleted) {
        this.todos = this.todos.map(function (todo) {
          if (todo.id === id) todo.isCompleted = true;
          return todo;
        });
        this.saveTodos();
      }
    },
    getTodos: function getTodos() {
      var todos = getLocal().todos;
      return todos;
    },
    saveTodos: function saveTodos() {
      saveLocal({
        todos: this.todos
      });
    },
    showSetting: function showSetting() {},
    redirectToTomato: function redirectToTomato(todo) {
      this.$router.push({ path: '/plugin/tomato', query: { from: 'todo', 'taskName': todo.text } });
    }
  }
});

function parseTodoText(val) {
  var arr = val.split(' ');
  if (arr.length <= 1) {
    return {
      text: val,
      duration: 1
    };
  }
  var duration = arr.pop();

  if (duration === '每天') {
    return {
      text: arr.join(' '),
      duration: 'everyday'
    };
  }
  var days = parseInt(duration, 10);
  if (typeof days === 'number') {
    return {
      text: arr.join(' '),
      duration: days
    };
  } else {
    return {
      text: val,
      duration: 1
    };
  }
}

/***/ }),

/***/ 714:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



var countTimer;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tomato',
  data: function data() {
    return {
      workTime: 1500,
      restTime: 360,
      isWorkTime: true,
      isPause: true,
      tomatoTime: 1500,
      tipWorkText: 'Tomato Work Time',
      tipRestText: 'Tomato Rest Time',
      taskName: '',
      settingFocusTime: 25,
      settingRestTime: 5
    };
  },
  created: function created() {
    var _$route$query = this.$route.query,
        from = _$route$query.from,
        taskName = _$route$query.taskName;

    this.taskName = taskName || '';
    switch (from) {
      case 'todo':
        break;
    }
  },

  computed: {
    toMinutsText: function toMinutsText() {
      var minutes = '' + Math.floor(this.tomatoTime / 60);
      var seconds = '' + this.tomatoTime % 60;
      minutes = minutes.length === 1 ? '0' + minutes : minutes;
      seconds = seconds.length === 1 ? '0' + seconds : seconds;
      var result = minutes + ':' + seconds;
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(result));
    }
  },
  methods: {
    toggleTomato: function toggleTomato() {
      var _this = this;

      if (!this.isPause) {
        clearTimeout(countTimer);
      } else {
        var countTime = function countTime() {
          _this.tomatoTime -= 1;
          countTimer = setTimeout(countTime, 1000);
        };
        countTime();
      }
      this.isPause = !this.isPause;
    },
    nextTomato: function nextTomato() {
      this.isWorkTime = !this.isWorkTime;
      this.tomatoTime = this.isWorkTime ? this.workTime : this.restTime;
      this.isPause = false;
      this.toggleTomato();
    },
    stopTomato: function stopTomato() {
      this.tomatoTime = this.isWorkTime ? this.workTime : this.restTime;
      this.isPause = true;
      clearTimeout(countTimer);
    },
    toggleRightSidenav: function toggleRightSidenav() {
      this.$refs.rightSidenav.toggle();
    },
    saveSetting: function saveSetting() {
      this.tomatoTime = this.settingFocusTime * 60;
      this.restTime = this.settingRestTime * 60;
      this.$refs.rightSidenav.close();
    }
  }
});

/***/ }),

/***/ 715:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'book',
  data: function data() {
    return {};
  },

  props: {
    progress: Number
  }
});

/***/ }),

/***/ 716:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_echarts__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_echarts__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pieChart',
  props: ['option'],
  mounted: function mounted() {
    this.init();
  },

  methods: {
    init: function init() {
      var myChart = __WEBPACK_IMPORTED_MODULE_0_echarts___default.a.init(this.$el);
      myChart.setOption(this.option, true);
    }
  },
  watch: {
    data: function data(newVal, oldVal) {
      this.init();
    }
  }
});

/***/ }),

/***/ 717:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'timeline',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 718:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'itemlineItem'
});

/***/ }),

/***/ 719:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'datePicker',
  props: {
    required: false,
    date: {
      type: Object,
      required: true
    },
    option: {
      type: Object,
      default: function _default() {
        return {
          type: 'day',
          SundayFirst: false,
          week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
          month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
          format: 'YYYY-MM-DD',
          color: {
            checked: '#F50057',
            header: '#3f51b5',
            headerText: '#fff'
          },
          inputStyle: {
            'display': 'inline-block',
            'padding': '6px',
            'line-height': '22px',
            'font-size': '16px',
            'border': '2px solid #fff',
            'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
            'border-radius': '2px',
            'color': '#5F5F5F'
          },
          placeholder: 'when?',
          buttons: {
            ok: 'OK',
            cancel: 'Cancel'
          },
          overlayOpacity: 0.5,
          dismissible: true
        };
      }
    },
    limit: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    function hours() {
      var list = [];
      var hour = 24;
      while (hour > 0) {
        hour--;
        list.push({
          checked: false,
          value: hour < 10 ? '0' + hour : hour
        });
      }
      return list;
    }
    function mins() {
      var list = [];
      var min = 60;
      while (min > 0) {
        min--;
        list.push({
          checked: false,
          value: min < 10 ? '0' + min : min
        });
      }
      return list;
    }
    return {
      hours: hours(),
      mins: mins(),
      showInfo: {

        hour: false,
        day: false,
        month: false,
        year: false,
        check: false
      },
      displayInfo: {
        month: ''
      },
      library: {
        week: this.option.week,
        month: this.option.month,
        year: []
      },
      checked: {
        oldtime: '',
        currentMoment: null,
        year: '',
        month: '',
        day: '',
        hour: '00',
        min: '00'
      },
      dayList: [],
      selectedDays: []
    };
  },

  methods: {
    pad: function pad(n) {
      n = Math.floor(n);
      return n < 10 ? '0' + n : n;
    },
    nextMonth: function nextMonth(type) {
      var next = null;
      type === 'next' ? next = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).add(1, 'M') : next = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).add(-1, 'M');
      this.showDay(next);
    },
    showDay: function showDay(time) {
      if (time === undefined || !Date.parse(time)) {
        this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
      } else {
        this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(time, this.option.format);
      }
      this.showOne('day');
      this.checked.year = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).format('YYYY');
      this.checked.month = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).format('MM');
      this.checked.day = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).format('DD');
      this.displayInfo.month = this.library.month[__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).month()];
      var days = [];
      var currentMoment = this.checked.currentMoment;
      var firstDay = __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).date(1).day();

      var previousMonth = __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment);
      var nextMonth = __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment);
      nextMonth.add(1, 'months');
      previousMonth.subtract(1, 'months');
      var monthDays = __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).daysInMonth();
      var oldtime = this.checked.oldtime;
      for (var i = 1; i <= monthDays; ++i) {
        days.push({
          value: i,
          inMonth: true,
          unavailable: false,
          checked: false,
          moment: __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).date(i)
        });
        if (i === Math.ceil(__WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).format('D')) && __WEBPACK_IMPORTED_MODULE_2_moment___default()(oldtime, this.option.format).year() === __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).year() && __WEBPACK_IMPORTED_MODULE_2_moment___default()(oldtime, this.option.format).month() === __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).month()) {
          days[i - 1].checked = true;
        }
        this.checkBySelectDays(i, days);
      }
      if (firstDay === 0) firstDay = 7;
      for (var _i = 0; _i < firstDay - (this.option.SundayFirst ? 0 : 1); _i++) {
        var passiveDay = {
          value: previousMonth.daysInMonth() - _i,
          inMonth: false,
          action: 'previous',
          unavailable: false,
          checked: false,
          moment: __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).date(1).subtract(_i + 1, 'days')
        };
        days.unshift(passiveDay);
      }
      if (this.limit.length > 0) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.limit), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var li = _step.value;

            switch (li.type) {
              case 'fromto':
                days = this.limitFromTo(li, days);
                break;
              case 'weekday':
                days = this.limitWeekDay(li, days);
                break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      var passiveDaysAtFinal = 42 - days.length;
      for (var _i2 = 1; _i2 <= passiveDaysAtFinal; _i2++) {
        var _passiveDay = {
          value: _i2,
          inMonth: false,
          action: 'next',
          unavailable: false,
          checked: false,
          moment: __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).add(1, 'months').date(_i2)
        };
        days.push(_passiveDay);
      }
      this.dayList = days;
    },
    checkBySelectDays: function checkBySelectDays(d, days) {
      var _this = this;

      this.selectedDays.forEach(function (day) {
        if (_this.checked.year === __WEBPACK_IMPORTED_MODULE_2_moment___default()(day).format('YYYY') && _this.checked.month === __WEBPACK_IMPORTED_MODULE_2_moment___default()(day).format('MM') && d === Math.ceil(__WEBPACK_IMPORTED_MODULE_2_moment___default()(day).format('D'))) {
          days[d - 1].checked = true;
        }
      });
    },
    limitWeekDay: function limitWeekDay(limit, days) {
      days.map(function (day) {
        if (limit.available.indexOf(Math.floor(day.moment.format('d'))) === -1) {
          day.unavailable = true;
        }
      });
      return days;
    },
    limitFromTo: function limitFromTo(limit, days) {
      var _this2 = this;

      if (limit.from || limit.to) {
        days.map(function (day) {
          if (_this2.getLimitCondition(limit, day)) {
            day.unavailable = true;
          }
        });
      }
      return days;
    },
    getLimitCondition: function getLimitCondition(limit, day) {
      var tmpMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.year + '-' + this.pad(this.checked.month) + '-' + this.pad(day.value));
      if (limit.from && !limit.to) {
        return !tmpMoment.isAfter(limit.from);
      } else if (!limit.from && limit.to) {
        return !tmpMoment.isBefore(limit.to);
      } else {
        return !tmpMoment.isBetween(limit.from, limit.to);
      }
    },
    checkDay: function checkDay(obj) {
      if (obj.unavailable || obj.value === '') {
        return false;
      }
      if (!obj.inMonth) {
        this.nextMonth(obj.action);
      }
      if (this.option.type === 'day' || this.option.type === 'min') {
        this.dayList.forEach(function (x) {
          x.checked = false;
        });
        this.checked.day = this.pad(obj.value);
        obj.checked = true;
      } else {
        var day = this.pad(obj.value);
        var ctime = this.checked.year + '-' + this.checked.month + '-' + day;
        if (obj.checked === true) {
          obj.checked = false;
          this.selectedDays.$remove(ctime);
        } else {
          this.selectedDays.push(ctime);
          obj.checked = true;
        }
      }
      switch (this.option.type) {
        case 'day':
          this.picked();
          break;
        case 'min':
          this.showOne('hour');

          this.shiftActTime();
          break;
      }
    },
    showYear: function showYear() {
      var _this3 = this;

      var year = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).year();
      this.library.year = [];
      var yearTmp = [];
      for (var i = year - 100; i < year + 5; ++i) {
        yearTmp.push(i);
      }
      this.library.year = yearTmp;
      this.showOne('year');
      this.$nextTick(function () {
        var listDom = document.getElementById('yearList');
        listDom.scrollTop = listDom.scrollHeight - 100;
        _this3.addYear();
      });
    },
    showOne: function showOne(type) {
      switch (type) {
        case 'year':
          this.showInfo.hour = false;
          this.showInfo.day = false;
          this.showInfo.year = true;
          this.showInfo.month = false;
          break;
        case 'month':
          this.showInfo.hour = false;
          this.showInfo.day = false;
          this.showInfo.year = false;
          this.showInfo.month = true;
          break;
        case 'day':
          this.showInfo.hour = false;
          this.showInfo.day = true;
          this.showInfo.year = false;
          this.showInfo.month = false;
          break;
        case 'hour':
          this.showInfo.hour = true;
          this.showInfo.day = false;
          this.showInfo.year = false;
          this.showInfo.month = false;
          break;
        default:
          this.showInfo.day = true;
          this.showInfo.year = false;
          this.showInfo.month = false;
          this.showInfo.hour = false;
      }
    },
    showMonth: function showMonth() {
      this.showOne('month');
    },
    addYear: function addYear() {
      var _this4 = this;

      var listDom = document.getElementById('yearList');
      listDom.addEventListener('scroll', function (e) {
        if (listDom.scrollTop < listDom.scrollHeight - 100) {
          var len = _this4.library.year.length;
          var lastYear = _this4.library.year[len - 1];
          _this4.library.year.push(lastYear + 1);
        }
      }, false);
    },
    setYear: function setYear(year) {
      this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(year + '-' + this.checked.month + '-' + this.checked.day);
      this.showDay(this.checked.currentMoment);
    },
    setMonth: function setMonth(month) {
      var mo = this.library.month.indexOf(month) + 1;
      if (mo < 10) {
        mo = '0' + '' + mo;
      }
      this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.year + '-' + mo + '-' + this.checked.day);
      this.showDay(this.checked.currentMoment);
    },
    showCheck: function showCheck() {
      if (this.date.time === '') {
        this.showDay();
      } else {
        if (this.option.type === 'day' || this.option.type === 'min') {
          this.checked.oldtime = this.date.time;
          this.showDay(this.date.time);
        } else {
          this.selectedDays = JSON.parse(this.date.time);
          if (this.selectedDays.length) {
            this.checked.oldtime = this.selectedDays[0];
            this.showDay(this.selectedDays[0]);
          } else {
            this.showDay();
          }
        }
      }
      this.showInfo.check = true;
    },
    setTime: function setTime(type, obj, list) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          item.checked = false;
          if (item.value === obj.value) {
            item.checked = true;
            this.checked[type] = item.value;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    picked: function picked() {
      if (this.option.type === 'day' || this.option.type === 'min') {
        var ctime = this.checked.year + '-' + this.checked.month + '-' + this.checked.day + ' ' + this.checked.hour + ':' + this.checked.min;
        this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(ctime, 'YYYY-MM-DD HH:mm');
        this.date.time = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).format(this.option.format);
      } else {
        this.date.time = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedDays);
      }
      this.showInfo.check = false;
      this.$emit('change', this.date.time);
    },
    dismiss: function dismiss(evt) {
      if (evt.target.className === 'datepicker-overlay') {
        if (this.option.dismissible === undefined || this.option.dismissible) {
          this.showInfo.check = false;
          this.$emit('cancel');
        }
      }
    },
    shiftActTime: function shiftActTime() {
      this.$nextTick(function () {
        if (!document.querySelector('.hour-item.active')) {
          return false;
        }
        document.querySelector('.hour-box').scrollTop = (document.querySelector('.hour-item.active').offsetTop || 0) - 250;
        document.querySelector('.min-box').scrollTop = (document.querySelector('.min-item.active').offsetTop || 0) - 250;
      });
    }
  }
});

/***/ }),

/***/ 74:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);


var toString = Object.prototype.toString;

/* harmony default export */ __webpack_exports__["a"] = (function (key) {
  return {
    getLocal: function getLocal() {
      var meta = window.localStorage.getItem(key);
      var result = '';
      if (meta) {
        result = JSON.parse(meta);
      }
      return result;
    },
    saveLocal: function saveLocal(data) {
      if (toString.call(data) !== '[object Object]') {
        console.error('localstorage: data must be object');
        return;
      }
      window.localStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
    },
    removeLocal: function removeLocal() {
      window.localStorage.removeItem(key);
    }
  };
});

/***/ })

},[696]);


// WEBPACK FOOTER //
// static/js/app.cbe5be17eda7ba870c61.js